{
    "subjectCategories": {
        "title": "Categorías de materias",
        "description": "Las categorías controlan las materias disponibles para todos los tutores y estudiantes. Las prácticas y los resultados existentes siguen accesibles. Escribe un motivo antes de cambiar una categoría.",
        "names": {
            "PRIMARY": "Primaria",
            "SECONDARY": "Secundaria",
            "BILINGUAL": "Colegios bilingües",
            "TECHNICAL": "Colegios técnicos"
        },
        "reason": "Motivo del cambio",
        "saving": "Guardando configuración global…",
        "saved": "Configuración global de categorías guardada.",
        "error": "No se pudo guardar la configuración de categorías. Revisa los valores actuales. Vuelve a intentarlo.",
        "empty": "No hay materias activas disponibles.",
        "unmapped": "Las materias activas sin categoría siguen disponibles por compatibilidad. Revisa estos códigos: {0}.",
        "countOne": "1 materia",
        "countOther": "{0} materias",
        "other": "Otras materias",
        "membershipHelp": "Asigna esta materia a una o varias categorías. Cada tutor elige qué categorías y materias aparecen al crear prácticas."
    },
    "marketing": {
        "nav": {
            "product": "Cómo funciona",
            "pricing": "Precios",
            "contact": "Contacto",
            "home": "Athena, ir al inicio",
            "primary": "Navegación principal"
        },
        "hero": {
            "eyebrow": "PRÁCTICAS PARA TUTORES Y ESTUDIANTES",
            "title": "Crea prácticas con tu material. Acompaña cada avance.",
            "description": "Convierte tu material de estudio en prácticas con ayuda de IA, revísalas y asígnalas a tus estudiantes. Ellos responden desde su cuenta; tú consultas sus resultados para decidir qué repasar.",
            "cta": "Empezar gratis",
            "secondary": "Descubre cómo funciona",
            "note": "También puedes crear tus prácticas manualmente.",
            "tag": "APRENDER. PRACTICAR. AVANZAR."
        },
        "preview": {
            "label": "Recorrido por Athena: crea, asigna y completa una práctica"
        },
        "steps": {
            "eyebrow": "CÓMO FUNCIONA ATHENA",
            "title": "Conecta tu cuenta con la de tus estudiantes.",
            "description": "Tutores y estudiantes tienen su propia cuenta. El tutor envía una solicitud de conexión y el estudiante la acepta en Athena para recibir prácticas.",
            "sequenceLabel": "Seis pasos desde la creación de las cuentas hasta la asignación de prácticas",
            "roles": {
                "tutor": "TUTOR",
                "student": "ESTUDIANTE",
                "connected": "VINCULADOS"
            },
            "tutorAccount": {
                "title": "El tutor crea su cuenta",
                "body": "El tutor se registra para preparar prácticas, acompañar a sus estudiantes y consultar su progreso."
            },
            "studentAccount": {
                "title": "El estudiante crea su cuenta",
                "body": "El estudiante se registra para tener su propio espacio donde recibir y completar prácticas."
            },
            "invitation": {
                "title": "El tutor envía una solicitud",
                "body": "El tutor envía una solicitud de conexión al estudiante."
            },
            "acceptInvitation": {
                "title": "El estudiante acepta en Athena",
                "body": "El estudiante revisa las solicitudes de tutores en su cuenta y decide si acepta o rechaza cada una."
            },
            "assignPractice": {
                "title": "El tutor asigna prácticas",
                "body": "Con las cuentas vinculadas, el estudiante recibe las prácticas asignadas y el tutor puede consultar sus resultados."
            }
        },
        "benefits": {
            "eyebrow": "ACOMPAÑA CADA PASO",
            "title": "Más claridad para ti. Más autonomía para ellos.",
            "family": {
                "title": "Todo en un mismo lugar",
                "body": "Prepara y asigna prácticas, organiza a tus estudiantes y consulta sus resultados desde tu cuenta de tutor."
            },
            "independence": {
                "title": "Su propio espacio",
                "body": "Cada estudiante responde desde su cuenta y puede guardar su avance para continuar después, dentro del plazo de la práctica."
            },
            "clarity": {
                "title": "Resultados para saber qué repasar",
                "body": "Consulta las notas y usa los resultados para decidir qué repasar."
            }
        },
        "pricing": {
            "eyebrow": "UN PLAN PARA CADA ETAPA",
            "title": "Elige un plan para tus prácticas.",
            "description": "Empieza gratis y elige un plan con más capacidad cuando lo necesites. Los estudiantes no necesitan una suscripción.",
            "compareTitle": "Compara los planes",
            "compareDescription": "Lo que incluye cada plan. Los estudiantes nunca necesitan un plan propio.",
            "freeDescription": "Para empezar con un estudiante.",
            "premiumDescription": "Para trabajar con más estudiantes y prácticas.",
            "plusDescription": "Más capacidad para prácticas y creación con IA.",
            "periodLabel": "Periodo de facturación",
            "periodMonthly": "1 mes",
            "periodQuarterly": "3 meses",
            "periodAnnual": "Anual",
            "recommended": "Recomendado",
            "pricePerMonth": "/ mes",
            "pricePerQuarter": "/ 3 meses",
            "pricePerYear": "/ año",
            "periodAnnouncement": "{0} seleccionado. Premium {1}; Premium Plus {2}.",
            "studentsOne": "Hasta {0} estudiante",
            "studentsOther": "Hasta {0} estudiantes",
            "practices": "{0} prácticas activas",
            "practicesUnlimited": "Prácticas activas ilimitadas",
            "questions": "Hasta {0} preguntas por práctica",
            "aiLifetime": "{0} generaciones de prácticas con IA, una sola vez",
            "aiMonthly": "{0} generaciones de prácticas con IA por mes",
            "multipleAttempts": "Múltiples intentos",
            "timed": "Prácticas cronometradas",
            "availability": "Fecha de fin y disponibilidad",
            "progressTracking": "Seguimiento de progreso completo",
            "attemptHistory": "Historial detallado de intentos",
            "request": "Consultar este plan",
            "note": "Nuestro equipo gestiona la activación de Premium y Premium Plus. Contáctanos para conocer los pasos."
        },
        "faq": {
            "eyebrow": "ANTES DE EMPEZAR",
            "title": "Resuelve tus dudas sobre Athena.",
            "ages": {
                "q": "¿Para quién es Athena?",
                "a": "Athena es para tutores que preparan y asignan prácticas, y para estudiantes que las completan desde su propia cuenta. Como tutor, eliges el material y adaptas las preguntas al nivel y los objetivos de tus estudiantes."
            },
            "accounts": {
                "q": "¿Necesito una cuenta de tutor?",
                "a": "Sí. La cuenta de tutor te permite preparar y asignar prácticas, y consultar resultados. Cada estudiante participa desde su propia cuenta."
            },
            "materials": {
                "q": "¿Puedo usar mi propio material de estudio?",
                "a": "Sí. Puedes escribir tus propias preguntas o crear una práctica con ayuda de IA a partir de fotos o PDF con texto legible. Los PDF escaneados o sin texto legible no son compatibles. La creación con IA está sujeta a disponibilidad y a los límites de tu plan."
            },
            "plans": {
                "q": "¿Cómo puedo activar un plan Premium o Premium Plus?",
                "a": "Solicita el plan que te interesa desde la sección de planes de tu cuenta. Nuestro equipo te indicará cómo realizar el pago y activará el plan una vez verificado."
            },
            "payment_options": {
                "q": "¿Cómo puedo pagar mi plan Premium o Premium Plus?",
                "a": "Puedes pagar por SINPE al número 7275-4063. Una vez que nuestro equipo verifique el pago, activaremos el plan que solicitaste."
            },
            "payment_time": {
                "q": "¿Cuánto tarda en activarse mi plan Premium o Premium Plus?",
                "a": "Tu plan se activará en cuanto nuestro equipo verifique el pago. La verificación puede tardar hasta 4 horas, según el momento en que realices el pago. Para agilizar el proceso, envía el comprobante por WhatsApp al +506 7275-4063."
            },
            "practices": {
                "q": "¿Qué es una práctica en Athena?",
                "a": "Una práctica es un conjunto de preguntas sobre un tema. El estudiante las responde desde su cuenta y recibe una nota al entregar su intento. Cuando agota los intentos permitidos, puede revisar las respuestas correctas y las explicaciones de sus errores, siempre que la práctica siga asignada y disponible."
            },
            "generation": {
                "q": "¿Cómo funciona la creación de prácticas con IA?",
                "a": "Sube fotos de tu material de estudio o PDF con texto legible, sin mezclar ambos formatos en una misma solicitud. Athena usa ese contenido para generar una propuesta de práctica con IA. Revisa las preguntas, respuestas y explicaciones, y edita lo necesario antes de guardarla. Cada plan incluye un número de generaciones con IA."
            }
        },
        "closing": {
            "title": "Prepara tu primera práctica en Athena.",
            "body": "Elige un tema y crea una práctica para asignarla a tus estudiantes."
        },
        "footer": {
            "tagline": "Aprender, mejor acompañados."
        },
        "contact": {
            "eyebrow": "CONTACTO",
            "title": "Estamos para acompañarte.",
            "body": "¿Tienes dudas sobre Athena, los planes o cómo empezar con tus estudiantes? Escríbenos por WhatsApp o correo electrónico.",
            "whatsappCta": "Escribir por WhatsApp",
            "message": "Hola, me gustaría saber más sobre Athena y sus planes.",
            "whatsappUnavailable": "La atención por WhatsApp estará disponible pronto.",
            "emailCta": "Enviar un correo",
            "emailSubject": "Consulta sobre Athena",
            "emailUnavailable": "La atención por correo estará disponible pronto.",
            "asideTitle": "Cuéntanos qué necesitas",
            "asideBody": "Cuéntanos con cuántos estudiantes trabajas y qué prácticas quieres preparar. Te ayudamos a conocer las opciones de Athena y elegir un plan."
        },
        "missing": {
            "title": "No encontramos esta página.",
            "back": "Volver al inicio"
        },
        "meta": {
            "title": "Athena · Prácticas para tutores y estudiantes",
            "description": "Crea prácticas con tu material de estudio, asígnalas a tus estudiantes y consulta sus resultados. Athena reúne la preparación y el seguimiento en un solo lugar.",
            "contactTitle": "Contacto · Habla con el equipo de Athena",
            "contactDescription": "Escríbenos por WhatsApp o correo para resolver dudas sobre Athena, los planes y cómo usarla con tus estudiantes.",
            "notFoundTitle": "Página no encontrada · Athena",
            "notFoundDescription": "Esta dirección no existe en Athena. Vuelve al inicio para conocer la plataforma de prácticas educativas.",
            "imageAlt": "Athena: convierte material de estudio en prácticas para tus estudiantes.",
            "applicationSubCategory": "Práctica educativa y evaluación",
            "browserRequirements": "Requiere un navegador web moderno con JavaScript activado"
        }
    },
    "common": {
        "loading": "Cargando…",
        "tryAgain": "Intentar de nuevo",
        "clear": "Limpiar",
        "clearFilters": "Limpiar filtros",
        "clearSearch": "Limpiar búsqueda",
        "review": "Revisar",
        "correct": "Correcto",
        "incorrect": "Incorrecto",
        "correctAnswer": "Respuesta correcta",
        "yourAnswer": "Tu respuesta",
        "best": "mejor",
        "ofTotal": "{0} de {1}",
        "saving": "Guardando…",
        "save": "Guardar cambios",
        "cancel": "Cancelar",
        "remove": "Quitar",
        "moveUp": "Subir",
        "moveDown": "Bajar",
        "creating": "Creando…",
        "opening": "Abriendo…"
    },
    "count": {
        "questionsOne": "1 pregunta",
        "questionsOther": "{0} preguntas",
        "attemptsOne": "1 intento",
        "attemptsOther": "{0} intentos",
        "studentsOne": "1 estudiante",
        "studentsOther": "{0} estudiantes",
        "problemsOne": "1 problema encontrado en el Markdown",
        "problemsOther": "{0} problemas encontrados en el Markdown",
        "markdownProblemsOne": "1 problema impidió leer esta práctica",
        "markdownProblemsOther": "{0} problemas impidieron leer esta práctica",
        "questionsReadOne": "1 pregunta leída",
        "questionsReadOther": "{0} preguntas leídas",
        "imagesOne": "1 imagen",
        "imagesOther": "{0} imágenes",
        "imagesReadOne": "Texto leído de 1 imagen",
        "imagesReadOther": "Texto leído de {0} imágenes",
        "practicesOne": "1 práctica",
        "practicesOther": "{0} prácticas",
        "availableOne": "1 disponible",
        "availableOther": "{0} disponibles",
        "matchesOne": "1 coincidencia",
        "matchesOther": "{0} coincidencias",
        "documentsOne": "1 PDF",
        "documentsOther": "{0} PDF",
        "minutesOne": "1 minuto",
        "minutesOther": "{0} minutos",
        "secondsOne": "1 segundo",
        "secondsOther": "{0} segundos",
        "questionsCreatedOne": "1 pregunta creada",
        "questionsCreatedOther": "{0} preguntas creadas"
    },
    "language": {
        "menuLabel": "Idioma",
        "es": "Español",
        "en": "English",
        "selected": "Seleccionado"
    },
    "navigation": {
        "skipToContent": "Saltar al contenido",
        "main": "Principal",
        "dashboard": "Panel",
        "practices": "Prácticas",
        "students": "Estudiantes",
        "home": "Inicio",
        "progress": "Progreso",
        "history": "Historial",
        "createPractice": "Crear práctica",
        "createPracticeShort": "Crear",
        "signOut": "Cerrar sesión",
        "brandHome": "Inicio de Athena"
    },
    "notFound": {
        "title": "Esa página no existe",
        "back": "Volver al panel"
    },
    "appError": {
        "unreachableTitle": "No se pudo conectar con Athena",
        "unreachableBody": "Revisa tu conexión a internet y vuelve a intentarlo.",
        "studentUnreachable": "No se pudo conectar con Athena. Revisa tu conexión a internet y vuelve a intentarlo.",
        "crashTitle": "No se pudo mostrar esta página",
        "crashBody": "Algo salió mal de nuestro lado. Vuelve a cargar la página para intentarlo de nuevo.",
        "reload": "Volver a cargar la página",
        "notSetUpTitle": "Tu cuenta aún no está configurada",
        "notSetUpBody": "Iniciaste sesión como {0}. Completa la configuración de tu cuenta para continuar."
    },
    "auth": {
        "signInTitle": "Inicia sesión o crea tu cuenta",
        "signInSubtitle": "Una sola entrada para todos. Si todavía no usas Athena, tu cuenta se crea al continuar, sin contraseñas.",
        "continueWithGoogle": "Continuar con Google",
        "continueWithMicrosoft": "Continuar con Microsoft",
        "providerDivider": "o",
        "providerFailed": "No se pudo iniciar. Vuelve a intentarlo o continúa con correo.",
        "providerCancelled": "Se canceló ese acceso. No ha cambiado nada.",
        "providerRejected": "No pudimos iniciar tu sesión con esa cuenta. Vuelve a intentarlo o continúa con correo.",
        "providerNoEmail": "Esa cuenta no compartió un correo electrónico, así que no podemos usarla. Continúa con correo.",
        "emailLabel": "Correo electrónico",
        "submit": "Continuar con correo",
        "submitInvite": "Envíame un código de acceso",
        "sending": "Enviando…",
        "codeSentTitle": "Revisa tu correo",
        "codeSentBody": "Si {0} puede usar Athena, ya va en camino un código de seis dígitos. Caduca en diez minutos.",
        "codeLabel": "Código de seis dígitos",
        "codeHelper": "Escribe el código del correo. Funciona una sola vez.",
        "codeSubmit": "Continuar",
        "verifying": "Continuando…",
        "codeInvalid": "Ese código no es correcto o ya caducó. Pide uno nuevo.",
        "codeRequired": "Escribe el código de seis dígitos del correo.",
        "resend": "Enviar otro código",
        "useAnotherEmail": "Usar otro correo electrónico",
        "requestFailed": "No se pudo completar. Revisa tu conexión y vuelve a intentarlo.",
        "inviteTitle": "Te han invitado",
        "inviteSubtitle": "Inicia sesión y tus prácticas estarán esperándote.",
        "inviteFailed": "No se pudo aceptar esa invitación.",
        "inviteRetry": "Intentar de nuevo",
        "emailOnlyHelper": "Inicia sesión con tu correo electrónico.",
        "emailHelper": "Te enviaremos un código de seis dígitos por correo.",
        "emailRequired": "Escribe tu correo electrónico.",
        "emailInvalid": "Escribe un correo completo, como nombre@ejemplo.com.",
        "backToSite": "Volver al sitio de Athena",
        "siteHome": "Sitio de Athena"
    },
    "onboarding": {
        "title": "Te damos la bienvenida a Athena",
        "subtitle": "¿Cómo usarás Athena?",
        "studentTitle": "Estudiante",
        "tutorTitle": "Tutor",
        "studentDescription": "Completa las prácticas asignadas y consulta tus resultados.",
        "tutorDescription": "Crea prácticas, asígnalas y acompaña el progreso de tus estudiantes.",
        "step": "Paso {0} de 2",
        "profileTitle": "Completa tu perfil",
        "firstName": "Nombre",
        "lastName": "Apellidos",
        "birthDate": "Fecha de nacimiento",
        "back": "Atrás",
        "continue": "Continuar",
        "saving": "Guardando perfil…",
        "completeProgress": "Configuración completa",
        "completeTitle": "Todo está listo",
        "completeBody": "Tu espacio en Athena está listo. Estamos abriendo tu panel…",
        "error": "No se pudo guardar tu perfil. Vuelve a intentarlo.",
        "nameError": "Escribe un nombre de entre 1 y 60 caracteres.",
        "dateError": "Escribe una fecha de nacimiento válida, desde 1900 hasta hoy."
    },
    "dashboard": {
        "title": "Panel",
        "loading": "Cargando tu panel…",
        "error": "No se pudo cargar tu panel. Vuelve a intentarlo.",
        "greeting": {
            "morning": "Buenos días",
            "morningNamed": "Buenos días, {0}",
            "afternoon": "Buenas tardes",
            "afternoonNamed": "Buenas tardes, {0}",
            "evening": "Buenas noches",
            "eveningNamed": "Buenas noches, {0}"
        },
        "subtitle": "Esto es lo que está pasando con tus estudiantes.",
        "filtersHeading": "Filtrar el panel",
        "needsAttention": "Necesita atención",
        "recentAttempts": "Intentos recientes",
        "noAttemptsTitle": "No hay intentos recientes",
        "noAttemptsForFilter": "Este estudiante todavía no ha entregado ninguna práctica con este filtro.",
        "firstPracticeTitle": "Crea tu primera práctica",
        "firstPracticeDescription": "Convierte material de estudio en una práctica interactiva en minutos.",
        "attention": {
            "emptyTitle": "Todo está en orden",
            "emptyDescription": "Ningún estudiante ni práctica necesita tu atención ahora mismo.",
            "viewPractice": "Ver práctica",
            "viewAttempt": "Ver intento",
            "viewStudent": "Ver estudiante",
            "closingSoon": "{0} · cierra {1}",
            "inProgress": "{0} · empezó {1}",
            "notStarted": "{0} · nada entregado",
            "showingMostUrgent": "Mostrando las {0} más urgentes de {1}."
        },
        "filters": {
            "student": "Estudiante",
            "everyStudent": "Todos los estudiantes",
            "practice": "Práctica",
            "everyPractice": "Todas las prácticas"
        },
        "feedProgressLabel": "{0}% · {1} de {2} · {3}"
    },
    "practice": {
        "title": "Práctica",
        "listTitle": "Prácticas",
        "loadingList": "Cargando prácticas…",
        "listError": "No se pudieron cargar tus prácticas. Vuelve a intentarlo.",
        "loadingOne": "Cargando práctica…",
        "loadError": "No se pudo cargar esa práctica.",
        "notFound": "No se encontró esa práctica.",
        "create": "Crear práctica",
        "newTitle": "Nueva práctica",
        "newSubtitle": "El primer encabezado de tu Markdown será el nombre de la práctica.",
        "searchSummary": "Mostrando prácticas que coinciden con",
        "nothingMatchesTitle": "No hay coincidencias",
        "nothingMatchesSearch": "Ninguna práctica tiene \"{0}\" en su nombre.",
        "nothingMatchesSearchFiltered": "Ninguna práctica de esta materia tiene \"{0}\" en su nombre.",
        "nothingMatchesFilters": "Ninguna práctica coincide con tus filtros.",
        "archivedHeading": "Archivadas",
        "archivedDescription": "Retiradas de tu lista activa. Nadie puede empezarlas y se conserva cada intento anterior.",
        "setAsideHeading": "Apartadas por tu plan",
        "setAsideDescription": "Tu plan mantiene menos prácticas activas de las que tienes. Estas no ocupan un lugar ni admiten asignaciones o intentos nuevos; se conserva cada versión y cada intento anterior. Recupera una cuando haya espacio.",
        "setAsideNotice": "Tu plan apartó esta práctica. No ocupa un lugar, y nadie puede recibirla ni empezarla hasta que la recuperes. Se conserva cada versión y cada intento anterior.",
        "archivedNotice": "Esta práctica está archivada. Nadie puede empezarla y se conserva cada intento anterior. Restáurala para devolverla a tu lista activa.",
        "noQuestionsYet": "Todavía sin preguntas",
        "publishedVersion": " · Versión publicada {0}",
        "unpublishedChanges": " · Cambios sin publicar",
        "publish": "Publicar",
        "publishing": "Publicando…",
        "assignedTo": "Asignada a",
        "settingsHeading": "Configuración de la práctica",
        "draftQuestions": "Preguntas del borrador",
        "questions": "Preguntas",
        "viewTabsLabel": "Cómo ver las preguntas",
        "viewWithAnswers": "Con respuestas",
        "viewAsStudent": "Como lo ve tu estudiante",
        "noQuestionsReplace": "Esta práctica todavía no tiene preguntas. Reemplaza el Markdown de abajo para agregarlas.",
        "replaceHeading": "Reemplazar con nuevo Markdown",
        "replaceDescription": "Al guardar se reemplazan todas las preguntas. Una versión publicada nunca cambia: esto guarda un borrador que publicas cuando esté listo.",
        "parseAndSaveDraft": "Guardar borrador",
        "versionHistory": "Historial de versiones",
        "version": "Versión {0}",
        "notPublished": "Sin publicar",
        "draftUpdated": "Borrador guardado.",
        "published": "Práctica publicada.",
        "created": "Práctica creada.",
        "unreadable": "No se pudo leer la práctica.",
        "pasteToStart": "Pega o arrastra Markdown para empezar.",
        "chooseSubject": "Elige una materia",
        "parsingAnnouncement": "Creando práctica",
        "createTabsLabel": "Cómo crear la práctica",
        "filters": {
            "subject": "Materia",
            "everySubject": "Todas las materias"
        },
        "fields": {
            "subject": "Materia",
            "chooseSubject": "Elige una materia",
            "subjectRequired": "Elige una materia.",
            "subjectHelper": "De qué trata esta práctica.",
            "availableUntil": "Disponible hasta",
            "availableUntilHelper": "Cuándo cierra la práctica. Después, no se puede empezar ni entregar ningún intento. Deja ambos campos vacíos para no poner fecha de fin.",
            "maxAttempts": "Máximo de intentos",
            "maxAttemptsHelper": "Cuenta solo los intentos entregados. Vacío significa sin límite.",
            "maxAttemptsInvalid": "Indica un número entero de intentos, o déjalo vacío para no poner límite.",
            "timed": "Práctica cronometrada",
            "timedHelper": "El estudiante tiene un tiempo fijo desde que empieza. Desactivado significa sin límite de tiempo.",
            "duration": "Duración",
            "durationHelper": "En minutos, entre {0} y {1}.",
            "durationInvalid": "Escribe un número entero de minutos entre {0} y {1}.",
            "timerVersionNote": "El límite de tiempo pertenece a la versión. Solo se puede cambiar mientras haya un borrador abierto.",
            "saveSettings": "Guardar configuración",
            "settingsSaved": "Configuración guardada.",
            "settingsSaveFailed": "No se pudo guardar la configuración. Vuelve a intentarlo.",
            "availableUntilTime": "Hora",
            "availableUntilTimeHelper": "En punto o y media.",
            "availableUntilTimePlaceholder": "Elige una hora",
            "availableUntilNeedsDate": "Elige una fecha para la hora de cierre, o borra la hora para no poner fecha de fin.",
            "availableUntilNeedsTime": "Elige una hora para la fecha de cierre, o borra la fecha para no poner fecha de fin.",
            "settingsNotSaved": "Tu configuración no se guardó.",
            "premiumOnly": "Disponible solo con los planes Premium.",
            "timedWithoutPlan": "Tu plan ya no incluye prácticas cronometradas. Desactiva el límite de tiempo para que tus estudiantes puedan volver a empezar esta práctica.",
            "endDateWithoutPlan": "Tu plan ya no incluye fechas de fin. La que está configurada aquí todavía cierra esta práctica. Quítala para mantener la práctica abierta.",
            "removeEndDate": "Quitar fecha de fin"
        },
        "automatic": {
            "tab": "Con IA",
            "generate": "Generar práctica",
            "readingAnnouncement": "Leyendo tus imágenes",
            "readAnnouncement": "Se leyeron tus imágenes.",
            "failedAnnouncement": "Algunas imágenes no se pudieron leer.",
            "readFailed": "Athena no pudo leer esas imágenes. Vuelve a intentarlo o escribe la práctica en la pestaña Manual.",
            "processing": "Generando…",
            "size": "Tamaño",
            "practiceType": "Tipo de práctica",
            "aiProvider": "Proveedor de IA",
            "providerGemini": "Gemini",
            "providerOpenAI": "OpenAI",
            "variousTypes": "Varios",
            "variousTypesHint": "Varios incluye selección múltiple, relacionar y respuesta corta.",
            "sizeLabel": {
                "S": "S",
                "M": "M",
                "L": "L",
                "XL": "XL"
            },
            "configHeading": "Configuración de la práctica",
            "generating": "Generando tu práctica…",
            "generatingBody": "Athena está escribiendo preguntas a partir de tus páginas. Puede tardar un minuto.",
            "generatingAnnouncement": "Generando tu práctica",
            "generatedAnnouncement": "Tu práctica fue creada.",
            "generationFailedAnnouncement": "No se pudo generar la práctica.",
            "generationFailedHeading": "No se pudo generar la práctica",
            "retry": "Intentar de nuevo",
            "retryHint": "Tus páginas se conservan, así que intentarlo de nuevo no vuelve a leerlas.",
            "sourceHeading": "¿Qué debe leer Athena?",
            "sourceImages": "Fotos de las páginas",
            "sourcePdfs": "Archivos PDF",
            "sourceLockedImages": "Estás usando fotos. Quítalas para usar PDF.",
            "sourceLockedPdfs": "Estás usando PDF. Quítalos para usar fotos.",
            "needSourceAndSubject": "Elige una materia y agrega al menos una foto o un PDF.",
            "readingPdfsAnnouncement": "Leyendo tus PDF",
            "readPdfsAnnouncement": "Se leyeron tus PDF.",
            "readSomePdfsAnnouncement": "Se leyeron tus PDF. No se pudieron usar {0}.",
            "pdfsFailedAnnouncement": "No se pudo leer ninguno de esos PDF.",
            "rejectedPdf": {
                "type": "{0} no es un PDF.",
                "size": "{0} pesa más de {1} MB.",
                "empty": "{0} está vacío.",
                "count": "Se omitió {0}: hasta {1} PDF a la vez.",
                "batch": "Se omitió {0}: juntos, los PDF serían demasiado grandes para leerlos a la vez."
            },
            "sizes": {
                "title": "Tamaño de las imágenes",
                "image": "Imagen",
                "uploaded": "Subida",
                "sent": "Enviada a Athena",
                "total": "Total"
            },
            "rejected": {
                "type": "{0} no es una imagen PNG, JPEG ni WebP.",
                "size": "{0} pesa más de {1} MB.",
                "count": "Se omitió {0}: hasta {1} imágenes a la vez.",
                "unreadable": "{0} no se pudo abrir como imagen.",
                "unreadableUnnamed": "No se pudo abrir esta imagen.",
                "duplicate": "{0} ya está en la lista."
            },
            "questionTypes": "Tipos de pregunta",
            "questionTypesHint": "Selecciona los tipos de pregunta que quieres incluir.",
            "questionTypesFreeHint": "Free incluye selección múltiple. Los otros tipos están disponibles con Premium.",
            "questionTypesRequired": "Selecciona al menos un tipo de pregunta.",
            "questionTypesInfo": "Acerca de los tipos de pregunta en Free"
        },
        "manual": {
            "tab": "Manual"
        },
        "archive": {
            "restore": "Restaurar práctica",
            "restoring": "Restaurando…",
            "archive": "Archivar práctica",
            "archiving": "Archivando…",
            "confirmTitle": "¿Archivar {0}?",
            "keep": "Mantenerla activa",
            "consequenceNone": "Ningún estudiante la tiene asignada. Se conservan todos los intentos y las notas, y puedes restaurarla en cualquier momento.",
            "consequenceOne": "1 estudiante ya no podrá empezarla. Se conservan todos los intentos y las notas, y puedes restaurarla en cualquier momento.",
            "consequenceOther": "{0} estudiantes ya no podrán empezarla. Se conservan todos los intentos y las notas, y puedes restaurarla en cualquier momento.",
            "archiveFailed": "La práctica no se archivó.",
            "restoreFailed": "La práctica no se restauró.",
            "archived": "Práctica archivada.",
            "restored": "Práctica restaurada."
        },
        "assign": {
            "addStudentFirst": "Agrega un estudiante antes de asignarle esta práctica a alguien.",
            "publishFirst": "Publica esta práctica antes de asignarla.",
            "assigned": "Asignada a {0}",
            "removed": "Quitada de {0}",
            "removeTitle": "¿Quitar esta práctica de {0}?",
            "removeTitleFallback": "¿Quitar esta práctica de este estudiante?",
            "removeConsequence": "{0} ya no podrá abrir esta práctica. Sus notas se quedan en su historial y puedes volver a asignársela cuando quieras.",
            "removeConsequenceFallback": "Ya no podrá abrir esta práctica. Sus notas se quedan en su historial y puedes volver a asignársela cuando quieras.",
            "removeFrom": "Quitar a {0}",
            "removeFallback": "Quitar práctica",
            "removing": "Quitando…",
            "keep": "Mantener asignada",
            "assignFailed": "No se asignó esta práctica a {0}.",
            "removeFailed": "No se quitó esta práctica a {0}."
        },
        "questionList": {
            "correctOrder": "Orden correcto",
            "accepted": "Se acepta: ",
            "correct": "Correcta"
        },
        "questionEdit": {
            "edit": "Editar la pregunta {0}",
            "delete": "Eliminar la pregunta {0}",
            "deleteTitle": "¿Eliminar la pregunta {0}?",
            "deleteDescription": "Esto elimina la pregunta de este borrador. Las versiones publicadas y los intentos anteriores no cambian.",
            "deleteConfirm": "Eliminar pregunta",
            "keep": "Conservar pregunta",
            "deleted": "Pregunta eliminada.",
            "saved": "Pregunta guardada.",
            "failed": "No se pudo guardar la pregunta.",
            "deleteFailed": "No se pudo eliminar la pregunta.",
            "prompt": "Pregunta",
            "explanation": "Explicación",
            "correctAnswer": "Respuesta correcta",
            "option": "Opción {0}",
            "addOption": "Agregar opción",
            "acceptedAnswer": "Respuesta aceptada {0}",
            "addAnswer": "Agregar respuesta aceptada",
            "correctOrder": "Orden correcto",
            "orderItem": "Posición {0}",
            "leftItem": "Elemento izquierdo {0}",
            "rightItem": "Elemento correspondiente {0}",
            "addPair": "Agregar pareja"
        },
        "newVersion": {
            "action": "Crear nueva versión",
            "creating": "Creando versión…",
            "description": "Copia las preguntas publicadas a un nuevo borrador editable. Las asignaciones y los intentos permanecen en su historial.",
            "created": "Se creó una nueva versión en borrador.",
            "failed": "No se pudo crear la nueva versión.",
            "publishBeforeRestore": "Publica el nuevo borrador antes de restaurar esta práctica."
        },
        "preview": {
            "questionProgress": "Pregunta {0} de {1}",
            "yourAnswer": "Tu respuesta",
            "typeYourAnswer": "Escribe tu respuesta"
        },
        "chatgpt": {
            "title": "Crear una práctica con ChatGPT",
            "description": "Copia el texto de abajo y pégalo en ChatGPT. Pega el resultado en el editor de texto.",
            "show": "Ver el texto",
            "promptLabel": "El texto para ChatGPT",
            "copy": "Copiar texto",
            "copied": "Texto copiado"
        },
        "editor": {
            "label": "Código Markdown",
            "placeholder": "# Fracciones\n\n## Pregunta 1\n¿Cuánto es 1/2 + 1/4?\n\n- A. 3/4\n- B. 2/6\n\n**Answer:** A\n\n## Pregunta 2\nOrdena estos pasos.\n\n- A. Suma los numeradores\n- B. Busca un denominador común\n- C. Simplifica\n\n**Type:** Association\n\n**Answer:** B, A, C\n\n## Pregunta 3\nRelaciona cada parte con lo que significa.\n\n**Type:** Matching\n\n- Numerador -> El número de arriba de la línea\n- Denominador -> El número de abajo de la línea"
        },
        "meta": {
            "active": "Activa",
            "archived": "Archivada",
            "archivedOn": "Archivada el {0}",
            "noEndDate": "Sin fecha de fin",
            "availableUntil": "Disponible hasta {0}",
            "unlimitedAttempts": "Intentos ilimitados",
            "attemptsEachOne": "1 intento cada uno",
            "attemptsEachOther": "{0} intentos cada uno",
            "notPublishedYet": "Sin publicar todavía",
            "notAssigned": "Sin asignar",
            "assignedToOne": "Asignada a 1 estudiante",
            "assignedToOther": "Asignada a {0} estudiantes",
            "updated": "Actualizada el {0}",
            "timed": "Cronometrada: {0}",
            "untimed": "Sin límite de tiempo"
        },
        "unpublishedChangesNote": "No estará disponible para los estudiantes hasta que publiques.",
        "publishFailed": "La práctica no se publicó.",
        "draftFailed": "Tu borrador no se guardó. Tu Markdown sigue aquí.",
        "createUnconfirmed": "Athena no pudo confirmar que la práctica se creó. Revisa tus prácticas antes de volver a crearla.",
        "preferences": {
            "navLabel": "Configuración",
            "title": "Configuración de prácticas",
            "subjectsTitle": "Materias para nuevas prácticas",
            "description": "Elige las categorías y materias que aparecen al crear una práctica. Primaria y Secundaria están seleccionadas inicialmente. Estas preferencias se aplican solo a tu cuenta en este navegador.",
            "search": "Buscar materias",
            "all": "Seleccionar todas",
            "save": "Guardar preferencias",
            "saved": "Preferencias guardadas.",
            "saveError": "Tu navegador no pudo guardar estas preferencias. Permite el almacenamiento local. Vuelve a intentarlo.",
            "required": "Selecciona al menos una materia.",
            "noResults": "No hay materias que coincidan. Borra la búsqueda o prueba otro nombre.",
            "loadError": "No se pudo cargar el catálogo de materias.",
            "selectionSummary": "Seleccionadas: {0} de {1}",
            "unsavedTitle": "¿Salir sin guardar las preferencias?",
            "unsavedBody": "Tu selección de materias no se ha guardado. Si sales, se perderán estos cambios.",
            "keepEditing": "Seguir editando",
            "discard": "Salir sin guardar"
        }
    },
    "questionType": {
        "MULTIPLE_CHOICE": "Selección múltiple",
        "TRUE_FALSE": "Verdadero o falso",
        "SHORT_ANSWER": "Respuesta corta",
        "ASSOCIATION": "Ordenar",
        "MATCHING": "Relacionar"
    },
    "student": {
        "backToStudents": "Volver a estudiantes",
        "title": "Estudiante",
        "listTitle": "Estudiantes",
        "listError": "No se pudo cargar esa lista. Vuelve a intentarlo.",
        "loadError": "No se pudo cargar ese estudiante.",
        "addHeading": "Agregar un estudiante",
        "yourStudents": "Tus estudiantes",
        "noneYet": "Aún no tienes estudiantes conectados. Envía una solicitud para comenzar.",
        "signedInAndReady": "Ya inició sesión",
        "noAccountYet": "Todavía sin cuenta",
        "signedIn": "Ya inició sesión",
        "lookingForScores": "¿Buscas las notas?",
        "openAPractice": "Abrir una práctica",
        "byPractice": "Por práctica",
        "noPracticeFinishedTitle": "{0} todavía no ha terminado una práctica",
        "noPracticeFinishedDescription": "Asigna una práctica y sus intentos aparecerán aquí agrupados por práctica.",
        "invite": {
            "pendingConnection": "Conexión con estudiante pendiente"
        },
        "history": {
            "scoreOnly": "Solo la nota",
            "summary": "Promedio {0}% · Mejor {1}% · {2}",
            "correctOf": "{0} de {1}"
        },
        "age": "{0} años",
        "noEmail": "Sin correo registrado",
        "noBirthDate": "Sin fecha de nacimiento",
        "setAsideDetail": "Apartado. No se le pueden asignar prácticas nuevas; su trabajo y sus notas están intactos."
    },
    "attempt": {
        "reviewNotIncluded": "Los intentos anteriores, pregunta por pregunta, forman parte de los planes de pago. La nota se conserva en la página del estudiante.",
        "title": "Intento",
        "loading": "Cargando intento…",
        "loadError": "No se pudo cargar ese intento.",
        "runnerLoadError": "No se pudo cargar esta práctica.",
        "runnerNotFound": "No se encontró esta práctica.",
        "noQuestions": "Esta práctica todavía no tiene preguntas.",
        "questionProgress": "Pregunta {0} de {1}",
        "yourAnswer": "Tu respuesta",
        "back": "Atrás",
        "next": "Siguiente",
        "submit": "Entregar",
        "checking": "Entregando…",
        "saveAndClose": "Guardar y cerrar",
        "stopTitle": "¿Parar por ahora?",
        "stopConsequence": "Se guardan tus respuestas y la pregunta en la que estás, y puedes retomar esta práctica donde la dejaste. Nada se califica hasta que entregues.",
        "keepGoing": "Seguir",
        "submitted": "Entregada. Obtuviste {0} de {1}.",
        "submitFailed": "No se pudo entregar. Vuelve a intentarlo.",
        "saveFailed": "No se pudo guardar. Vuelve a intentarlo.",
        "autosaveFailed": "Tu última respuesta todavía no está guardada.",
        "autosaveRetrying": "Athena lo seguirá intentando automáticamente. Revisa tu conexión a internet.",
        "autosaveRecovered": "Tus respuestas están guardadas.",
        "submitNotSaved": "Tu práctica todavía no se entregó, porque no se pudieron guardar tus respuestas.",
        "leaveUnsavedTitle": "¿Salir antes de que se guarde tu respuesta?",
        "leaveUnsavedConsequence": "Tu última respuesta todavía no está guardada. Si sales ahora, se puede perder.",
        "leaveAnyway": "Salir de todos modos",
        "unansweredOne": "Todavía hay 1 pregunta sin responder",
        "unansweredOther": "Todavía hay {0} preguntas sin responder",
        "unansweredConsequence": "Al entregar, este intento termina y no se puede deshacer. Puedes volver y terminarlas primero, o entregarlo tal como está.",
        "finishAnswering": "Terminar de responder",
        "submitAnyway": "Entregar de todos modos",
        "attemptNumber": "Intento {0}",
        "tryAgain": "Intentar de nuevo",
        "backToPractices": "Volver a mis prácticas",
        "yourAttempts": "Tus intentos",
        "firstAttempt": "Este es tu primer intento.",
        "review": {
            "title": "Qué pasó, pregunta por pregunta",
            "loading": "Cargando tus resultados…",
            "unavailable": "Tu nota está guardada. Las respuestas pregunta por pregunta no están disponibles para esta práctica.",
            "allRight": "Todas las preguntas estaban bien.",
            "toLookAtOne": "1 pregunta para repasar.",
            "toLookAtOther": "{0} preguntas para repasar.",
            "correct": "✓ Correcta",
            "notRight": "✕ Incorrecta",
            "youPut": "Pusiste",
            "theAnswer": "La respuesta",
            "youPutLabel": "Pusiste: ",
            "theAnswerLabel": "La respuesta: ",
            "nothing": "nada"
        },
        "tutorReview": {
            "credit": "{0} de {1}",
            "studentPut": "{0} puso",
            "matches": "Relaciones",
            "studentsAnswer": "La respuesta de {0}",
            "correctOrder": "Orden correcto",
            "choseThis": "{0} eligió esta",
            "correctAnswer": "Respuesta correcta",
            "theirAnswer": "Su respuesta: ",
            "leftBlank": "En blanco",
            "accepted": "Se acepta: "
        },
        "timer": {
            "remaining": "Tiempo restante: {0}",
            "expired": "Se acabó el tiempo",
            "expiredAnnouncement": "Se acabó el tiempo. Tu práctica se entregó.",
            "warningAnnouncement": "Quedan {0}.",
            "criticalAnnouncement": "Solo quedan {0}."
        },
        "stopTimedTitle": "¿Salir de esta práctica?",
        "stopTimedConsequence": "Tus respuestas se guardan, pero el reloj sigue corriendo mientras no estés. Cuando se acabe el tiempo, la práctica se entrega tal como esté.",
        "saveAndLeave": "Guardar y salir",
        "expiredNotice": "Se acabó el tiempo. Esta práctica se entregó con las respuestas que habías guardado.",
        "savedAndClosed": "Tu progreso quedó guardado."
    },
    "learn": {
        "title": "Tus prácticas",
        "loadError": "No se pudieron cargar tus prácticas.",
        "startFailed": "No se pudo abrir esa práctica.",
        "emptyTitle": "Todavía no hay nada que practicar",
        "emptyDescription": "Cuando alguien te asigne una práctica, aparecerá aquí.",
        "continueHeading": "Continuar práctica",
        "availableHeading": "Prácticas disponibles",
        "nothingNew": "Nada nuevo por empezar ahora mismo. Bien hecho.",
        "nothingToStart": "Ahora no se puede empezar ninguna. Cada práctica de abajo dice por qué.",
        "card": {
            "attemptsLeft": "Intentos restantes: {0} de {1}",
            "until": "Hasta el {0}",
            "start": "Empezar",
            "startNamed": "Empezar {0}",
            "tryAgain": "Intentar de nuevo",
            "tryAgainNamed": "Intentar de nuevo: {0}",
            "notAvailable": "No disponible en este momento",
            "blockedArchived": "Archivada por tu tutor",
            "blockedClosed": "Ya no está disponible",
            "blockedMaxAttempts": "Ya usaste todos tus intentos",
            "blockedNotPublished": "Todavía no está disponible",
            "timed": "Cronometrada · {0}"
        },
        "continue": {
            "readyToResume": "Lista para retomarla donde la dejaste",
            "questionProgress": "Pregunta {0} de {1}",
            "resume": "Continuar práctica"
        },
        "timed": {
            "dialogTitle": "Esta práctica es cronometrada",
            "dialogDuration": "Tendrás {0} desde el momento en que empieces.",
            "dialogRules": "El reloj no se puede pausar. Cerrar la práctica, o tu navegador, no lo detiene. Cuando se acabe el tiempo, la práctica se entrega con las respuestas que hayas guardado.",
            "dialogStart": "Empezar práctica",
            "dialogCancel": "Todavía no"
        },
        "group": {
            "noneAvailable": "nada para empezar ahora"
        }
    },
    "history": {
        "title": "Tu historial",
        "loadError": "No se pudo cargar tu historial. Vuelve a intentarlo.",
        "emptyTitle": "Todavía no has terminado nada",
        "emptyDescription": "Cuando entregues una práctica, se queda aquí con tu nota, incluso después de salir de tu lista.",
        "intro": "Todas las prácticas que has terminado. Tus notas se quedan aquí para siempre.",
        "detail": "{0} · Entregada el {1}",
        "seeTheAnswers": "Ver las respuestas",
        "scoreOnly": "Solo la nota",
        "blockedUnassigned": "Ya no está en tu lista",
        "blockedArchived": "Archivada por tu tutor",
        "blockedClosed": "Ya no está disponible",
        "blockedAttemptsRemaining": "Todavía te queda un intento",
        "blockedNotSubmitted": "Todavía sin entregar"
    },
    "progress": {
        "withheldNote": "Algunas mejores notas no se muestran porque forman parte de un plan de pago del tutor. Se conserva cada nota que obtuviste.",
        "title": "Tu progreso",
        "intro": "Cada práctica que has terminado y cómo te fue cada vez.",
        "loadError": "No se pudo cargar tu progreso.",
        "emptyTitle": "Todavía no hay nada que mostrar",
        "emptyDescription": "Tu progreso aparecerá aquí cuando termines una práctica.",
        "emptyAction": "Ir a tus prácticas",
        "practice": {
            "latest": "Último",
            "best": "Mejor",
            "evolution": "Evolución",
            "lastOn": "Último intento: {0}",
            "sequenceLabel": "Tus resultados en {0}, del primero al último",
            "allAttempts": "Todos los intentos",
            "seeTheAnswersNamed": "Ver las respuestas de {0}"
        }
    },
    "admin": {
        "includedFeatures": "Incluido en este plan",
        "noPaidFeatures": "Sin funciones de pago: un intento, sin límite de tiempo ni fecha de fin, y notas sin promedios ni respuestas anteriores",
        "badge": "Administración",
        "navLabel": "Administración",
        "navUsers": "Cuentas",
        "navRequests": "Solicitudes",
        "noAccessTitle": "Esta área es para administradores",
        "noAccessBody": "Inicia sesión en Athena con una cuenta de administrador y vuelve.",
        "signOutFailedTitle": "Es posible que tu sesión siga abierta",
        "signOutFailedBody": "Athena no pudo confirmar que tu sesión terminó. Revisa tu conexión y vuelve a cerrar sesión, o cierra este navegador antes de que otra persona lo use.",
        "openAthena": "Abrir Athena",
        "loadError": "No se pudo cargar.",
        "usersTitle": "Cuentas",
        "searchLabel": "Buscar por nombre o correo",
        "noUsers": "Ninguna cuenta coincide con estos filtros.",
        "roleTutor": "Tutor",
        "roleStudent": "Estudiante",
        "roleAdmin": "Administrador",
        "accountCreated": "Cuenta creada el {0}",
        "noSubscriptionTitle": "Sin perfil de tutor",
        "noSubscriptionBody": "Las suscripciones pertenecen a las cuentas de tutor. Un estudiante no necesita ninguna: su acceso viene del tutor que le asignó la práctica.",
        "subscriptionTitle": "Suscripción",
        "storedPlan": "Guardado",
        "enforcedPlan": "Límites aplicados",
        "enforcementPending": "Aún no aplicados a sus recursos",
        "since": "Desde el {0}",
        "lapsedTitle": "El acceso de pago terminó",
        "lapsedBody": "Registrado como pagado hasta el {0}. La cuenta tiene el plan Gratis.",
        "period": "Mes actual",
        "accessEnds": "Pagado hasta",
        "scheduled": "Cambio programado",
        "students": "Estudiantes",
        "practices": "Prácticas activas",
        "blockedTitle": "Prácticas que ningún estudiante puede empezar",
        "blockedTimed": "cronometrada",
        "manageTitle": "Administrar el plan",
        "manageBody": "Athena no cobra. Esto registra un acuerdo hecho en otro sitio, y cada acción queda en el registro de auditoría con tu nombre y tu motivo.",
        "planLabel": "Plan",
        "planPlaceholder": "Elige un plan",
        "accessEndsLabel": "Fecha",
        "accessEndsHelper": "Pagado hasta, al asignar; la fecha efectiva, al programar.",
        "assignPlan": "Asignar ahora",
        "scheduleChange": "Programar para después",
        "endAccess": "Finalizar el acceso de pago",
        "endAccessTitle": "¿Terminar el acceso de pago el {0}?",
        "endAccessBody": "Desde el {0}, esta cuenta pasa al plan Gratis, cuyos límites son {1} para estudiantes, {2} para prácticas activas y {3} para preguntas por práctica, sin prácticas cronometradas. Lo que no quepa se aparta, no se elimina, y vuelve si se asigna de nuevo un plan de pago.",
        "keepPaidAccess": "Mantener el acceso de pago",
        "aiTitle": "Uso de IA",
        "aiBody": "Las correcciones son filas nuevas del registro, nunca ediciones: lo que el tutor gastó realmente se queda como está.",
        "aiAdjustmentTitle": "Nuevo ajuste",
        "aiHistoryEmpty": "Aún no hay uso de IA registrado.",
        "adjustmentLabel": "Ajuste",
        "adjustmentHelper": "Negativo devuelve créditos; positivo los retira.",
        "adjust": "Registrar ajuste",
        "relationshipsTitle": "Estudiantes",
        "relationshipsEmpty": "Aún no hay estudiantes conectados.",
        "accountSections": "Secciones de la cuenta",
        "suspended": "Apartado",
        "enabled": "Activa",
        "requestsTitle": "Solicitudes de mejora",
        "requestsBody": "Un tutor ha pedido pasar a un plan de pago. Aprobar responde a la solicitud y aplica el plan; rechazar responde y no cambia nada.",
        "requestsEmpty": "No hay solicitudes pendientes de revisión.",
        "decisionNote": "Nota que registrar",
        "approve": "Aprobar y aplicar",
        "decline": "Rechazar",
        "auditTitle": "Registro de auditoría",
        "auditEmpty": "Aún no hay historial de auditoría.",
        "auditLoadMore": "Cargar más",
        "auditLoadingMore": "Cargando más…",
        "auditDetails": "Ver los cambios sin procesar",
        "auditBefore": "Antes",
        "auditAfter": "Después",
        "auditDeletedActor": "Un administrador eliminado",
        "auditActionGeneric": "Cambio administrativo",
        "auditActionUserCreated": "Usuario creado",
        "auditActionUserUpdated": "Usuario actualizado",
        "auditActionUserFeatureFlagUpdated": "Función experimental del usuario actualizada",
        "auditActionUserFeatureFlagsUpdated": "Funciones experimentales del usuario actualizadas",
        "auditFieldFeatureFlag": "Función experimental",
        "auditFieldEnabled": "Habilitada",
        "auditActionUserDeleted": "Usuario eliminado",
        "auditActionSubjectCreated": "Materia creada",
        "auditActionSubjectUpdated": "Materia actualizada",
        "auditActionSubjectDeleted": "Materia eliminada",
        "auditActionSubscriptionChanged": "Suscripción cambiada",
        "auditActionUsageChanged": "Uso de IA cambiado",
        "planNotChanged": "El plan no se cambió.",
        "adjustmentUnconfirmed": "Athena no pudo confirmar que el ajuste se registró. Revisa el historial antes de volver a ajustar.",
        "decisionNotMade": "La solicitud no se respondió.",
        "requestApproved": "Solicitud de {0} aprobada.",
        "requestDeclined": "Solicitud de {0} rechazada.",
        "titleSuffix": "Administración de Athena",
        "accountPageTitle": "Cuenta",
        "notFoundBack": "Volver a las cuentas",
        "noAccounts": "Aún no hay cuentas.",
        "accountsCountOne": "1 cuenta",
        "accountsCountOther": "{0} cuentas",
        "allProfiles": "Todos los perfiles",
        "allStatuses": "Todos los estados",
        "columnAccount": "Cuenta",
        "columnProfiles": "Perfiles",
        "columnStatus": "Estado",
        "columnCreated": "Creada",
        "noProfile": "Sin perfil",
        "statusActive": "Activa",
        "statusDisabled": "Deshabilitada",
        "statusInvited": "Invitación pendiente",
        "emailUnverified": "Correo sin verificar",
        "emailVerified": "Correo verificado",
        "pagination": "Páginas",
        "listLoadError": "No se pudo cargar la lista. Tu búsqueda y tus filtros se conservan.",
        "sectionAccess": "Acceso",
        "accessActiveBody": "Esta cuenta puede iniciar sesión.",
        "accessDisabledBody": "Esta cuenta está deshabilitada y no puede iniciar sesión. Todo lo que le pertenece se conserva.",
        "technicalDetails": "Detalles técnicos",
        "techUserId": "ID de usuario",
        "techTutorId": "ID de tutor",
        "techStudentId": "ID de estudiante",
        "techPlanCodes": "Códigos de plan (guardado · vigente · límites aplicados)",
        "techEntryId": "ID de la entrada",
        "techAction": "Código de la acción",
        "techRecord": "Registro",
        "planInForce": "Plan vigente",
        "capacityValue": "{0} de {1}",
        "capacityOver": "{0} por encima del límite",
        "aiCredits": "Créditos de IA este mes",
        "aiCreditsValue": "{0} usados de {1}",
        "aiCreditsHeldOne": "1 reservado para una solicitud en curso",
        "aiCreditsHeldOther": "{0} reservados para solicitudes en curso",
        "scheduledValue": "{0} desde el {1}",
        "scheduledByAdmin": "Programado por un administrador. El tutor no puede cancelarlo.",
        "scheduledByTutor": "Programado por el tutor, que puede cancelarlo.",
        "noScheduledChange": "Ninguno",
        "noEndDate": "Sin fecha de fin",
        "planActionsRoutine": "Asignar o programar un plan queda registrado con tu motivo y se puede volver a cambiar en cualquier momento.",
        "endAccessHeading": "Finalizar el acceso de pago",
        "endAccessHelp": "Desde la fecha de arriba, la cuenta pasa al plan Gratis. Lo que no quepa se aparta, no se elimina.",
        "aiHistoryCaption": "Historial de uso de IA",
        "columnWhen": "Cuándo",
        "columnEvent": "Evento",
        "columnCredits": "Créditos",
        "columnNote": "Nota",
        "usageKindGeneration": "Generación de práctica con IA",
        "usageKindAdjustment": "Ajuste manual",
        "usageKindExtraction": "Lectura de imágenes con IA",
        "usageStatusConsumed": "Usado",
        "usageStatusReserved": "Reservado",
        "usageStatusReleased": "Liberado, sin cobro",
        "usageStatusFailedFree": "Falló, sin cobro",
        "usageStatusFailedCharged": "Falló, con cobro (fallos gratuitos agotados)",
        "creditsOne": "1 crédito",
        "creditsOther": "{0} créditos",
        "creditsReturnedOne": "1 crédito devuelto",
        "creditsReturnedOther": "{0} créditos devueltos",
        "relationshipsCaption": "Estudiantes conectados",
        "columnStudent": "Estudiante",
        "columnEmail": "Correo",
        "columnConnected": "Conectado",
        "suspendedByPlan": "Apartado por un límite del plan",
        "suspendedByTutor": "Apartado por el tutor",
        "unclaimed": "Invitación no aceptada",
        "requestedPlan": "Plan solicitado",
        "requestedOn": "Solicitada el {0}",
        "tutorMessage": "Mensaje del tutor",
        "decisionNoteHelper": "Obligatoria para aprobar o rechazar. Queda en el registro de auditoría.",
        "findAccount": "Abrir en cuentas",
        "requestsCountOne": "1 solicitud pendiente",
        "requestsCountOther": "{0} solicitudes pendientes",
        "subjectsCountOne": "1 materia",
        "subjectsCountOther": "{0} materias",
        "subjectsCaption": "Materias",
        "searchSubjects": "Buscar por código o nombre",
        "noSubjects": "Aún no hay materias.",
        "noMatchingSubjects": "Ninguna materia coincide con estos filtros.",
        "columnSubject": "Materia",
        "columnPractices": "Prácticas",
        "subjectDetails": "Datos de la materia",
        "subjectAvailability": "Disponibilidad",
        "subjectAvailable": "Disponible para prácticas nuevas",
        "subjectStatusActive": "Activa",
        "subjectStatusInactive": "Inactiva",
        "auditActorTutor": "El tutor, desde su pantalla de plan",
        "auditActorAutomatic": "Athena, automáticamente",
        "auditReason": "Motivo",
        "auditNoFields": "No se registraron cambios por campo.",
        "auditActionUserDisabled": "Cuenta deshabilitada",
        "auditActionUserReactivated": "Cuenta reactivada",
        "auditActionPlanAssigned": "Plan asignado",
        "auditActionChangeScheduled": "Cambio de plan programado",
        "auditActionAccessEnded": "Acceso de pago finalizado",
        "auditActionRequestApproved": "Solicitud de mejora aprobada",
        "auditActionRequestDeclined": "Solicitud de mejora rechazada",
        "auditActionLimitsEnforced": "Límites del plan aplicados",
        "auditActionDowngradeScheduled": "Cambio a un plan menor programado",
        "auditActionDowngradeCancelled": "Cambio a un plan menor cancelado",
        "auditFieldPlan": "Plan",
        "auditFieldPlanInForce": "Plan vigente",
        "auditFieldAccessEnds": "Pagado hasta",
        "auditFieldAnchor": "Aniversario mensual",
        "auditFieldScheduledPlan": "Plan programado",
        "auditFieldScheduledAt": "Entra en vigor",
        "auditFieldAccess": "Acceso",
        "auditFieldTutor": "Perfil de tutor",
        "auditFieldStudent": "Perfil de estudiante",
        "auditFieldAdmin": "Administrador",
        "auditFieldLanguage": "Idioma preferido",
        "auditFieldProfiles": "Perfiles",
        "auditFieldEmail": "Correo",
        "auditFieldCode": "Código",
        "auditFieldSubjectStatus": "Estado",
        "auditFieldSpanishName": "Nombre en español",
        "auditFieldEnglishName": "Nombre en inglés",
        "auditFieldName": "Nombre",
        "auditFieldProfileNames": "Nombres de perfil",
        "auditFieldCreditsUsed": "Créditos de IA usados",
        "auditFieldCreditsLeft": "Créditos de IA restantes",
        "auditFieldAdjustment": "Ajuste",
        "auditFieldRequestedPlan": "Plan solicitado",
        "auditFieldRequestStatus": "Solicitud",
        "auditFieldStudentsSetAside": "Estudiantes apartados",
        "auditFieldPracticesSetAside": "Prácticas apartadas",
        "auditFieldInvitationsRevoked": "Invitaciones revocadas",
        "auditFieldRecord": "Registro",
        "auditValueYes": "Sí",
        "auditValueNo": "No",
        "auditValueChanged": "Cambiado",
        "auditValueDeleted": "Eliminado",
        "auditValueVerified": "Verificado",
        "auditValueUnverified": "Sin verificar",
        "auditValueDeclined": "Rechazada",
        "auditValueApproved": "Aprobada",
        "auditValuePending": "Pendiente",
        "auditValueWithdrawn": "Retirada",
        "auditValueNone": "Ninguno",
        "auditActorLabel": "Hecho por",
        "studentLimitTitle": "Límite de estudiantes",
        "studentLimitBody": "Configura un límite de estudiantes para el plan de pago de este tutor. Deja el campo vacío para usar el límite del plan ({0}). Free siempre usa su propio límite.",
        "studentLimitLabel": "Límite personalizado de estudiantes",
        "studentLimitSave": "Guardar límite de estudiantes",
        "studentLimitInvalid": "Ingresa un número entero positivo o deja el campo vacío para usar el límite del plan.",
        "studentLimitUnconfirmed": "Cambio de límite de estudiantes sin confirmar",
        "studentLimitFree": "Los límites personalizados de estudiantes solo se aplican mientras haya un plan de pago activo."
    },
    "subscription": {
        "upgradeInterest": "Solicitar {0}",
        "upgradeConfirmTitle": "¿Solicitar acceso a {0}?",
        "upgradeConfirmBody": "Enviarás una solicitud de acceso a {0}. Tu plan actual se mantendrá sin cambios hasta que un administrador apruebe y active tu acceso.",
        "upgradeCancel": "Ahora no",
        "requestPending": "Solicitud pendiente",
        "title": "Plan y uso",
        "navLabel": "Plan",
        "loadError": "No se pudo cargar tu plan.",
        "currentPlan": "Plan actual",
        "perMonth": "{0} al mes",
        "free": "Gratis",
        "planName": {
            "FREE": "Gratis",
            "PREMIUM": "Premium",
            "PREMIUM_PLUS": "Premium Plus"
        },
        "since": "En este plan desde el {0}",
        "periodEnds": "Este mes termina el {0}",
        "accessEnds": "El acceso de pago está registrado hasta el {0}",
        "lapsedTitle": "El acceso de pago terminó",
        "lapsedBody": "Esta cuenta tiene el plan Gratis. Solicita una mejora para recuperar los límites del plan de pago.",
        "usageHeading": "Uso y límites",
        "planLimitsHeading": "Lo que permite este plan",
        "questionsUpTo": "Hasta {0} preguntas por práctica",
        "timedIncluded": "Incluye prácticas cronometradas",
        "timedNotIncluded": "Este plan no incluye prácticas cronometradas",
        "atLimitStudents": "Llegaste al límite de estudiantes de este plan.",
        "atLimitPractices": "Llegaste al límite de prácticas activas de este plan.",
        "unlimited": "ilimitadas",
        "unlimitedUsage": "{0} usadas, ilimitadas",
        "unlimitedCapacity": "Sin límite de prácticas activas",
        "atLimitAskLarger": "Solicita un plan mayor abajo para agregar más.",
        "studentsLabel": "Estudiantes conectados",
        "practicesLabel": "Prácticas activas",
        "aiLabel": "Generaciones con IA",
        "ofLimit": "{0} de {1}",
        "remainingCount": "Disponibles: {0}",
        "reservedNote": "{0} en curso",
        "invitationsReservedOne": "1 reservado por una invitación",
        "invitationsReservedOther": "{0} reservados por invitaciones",
        "aiResets": "Se renueva el {0}",
        "aiIntroductory": "De bienvenida, y no se renuevan",
        "aiNoneLeft": "No queda ninguna",
        "overLimitTitle": "Superas tu plan",
        "overLimitStudents": "Tienes {0} estudiantes y este plan permite {1}.",
        "overLimitPractices": "Tienes {0} prácticas activas y este plan permite {1}.",
        "overLimitBody": "No se te ha quitado nada. No puedes agregar más hasta que liberes espacio o pases a un plan mayor.",
        "blockedHeading": "Prácticas que tus estudiantes no pueden abrir",
        "blockedBody": "Aquí no se ha cambiado nada. Abre una práctica para arreglarla: acorta una larga y publícala, o desactiva su límite de tiempo. Pasar a un plan mayor también las abre.",
        "blockedAction": "Abrir práctica",
        "blockedTooLong": "{0} preguntas, y este plan permite {1}",
        "blockedTimed": "Cronometrada, y las prácticas cronometradas forman parte de los planes de pago",
        "blockedState": "No se puede abrir",
        "resourceName": "Nombre",
        "resourceReason": "Motivo",
        "resourceState": "Estado",
        "resourceAction": "Acción",
        "currentBadge": "Tu plan",
        "upgradeMessageLabel": "Algo que quieras agregar",
        "upgradeMessagePlaceholder": "Opcional",
        "upgradeSubmit": "Enviar solicitud",
        "upgradeSubmitting": "Enviando…",
        "upgradeSent": "Solicitud enviada para {0}.",
        "pendingHeading": "Solicitud a la espera de respuesta",
        "pendingBody": "Pediste {0} el {1}. Todavía no ha cambiado nada: sigues en {2}.",
        "pendingWithdraw": "Retirar solicitud",
        "declinedHeading": "Tu última solicitud fue rechazada",
        "declinedBody": "Pediste {0} el {1}.",
        "downgradeHeading": "Pasar a un plan menor",
        "downgradeBody": "El cambio se aplica al terminar el mes que has pagado, el {0}. No se devuelve nada, porque Athena no cobra dentro de la aplicación.",
        "downgradeSubmit": "Programar el paso a {0}",
        "scheduledHeading": "Cambio a un plan menor programado",
        "scheduledBody": "Esta cuenta pasa a {0} el {1}.",
        "scheduledCancel": "Cancelar el cambio programado",
        "selectionHeading": "Elige qué sigue activo",
        "selectionBody": "El {0} este plan mantiene {1} estudiantes y {2} prácticas. Elige qué conservar; lo que no elijas se aparta, empezando por lo más antiguo. No se borra nada y podrás recuperarlo más adelante.",
        "selectionStudents": "Estudiantes que conservar",
        "selectionPractices": "Prácticas que conservar",
        "selectionSave": "Guardar elección",
        "selectionSaved": "Tu elección se ha guardado.",
        "selectionTooMany": "Elige como máximo {0}.",
        "suspendedStudentsHeading": "Estudiantes apartados",
        "suspendedStudentsBody": "Su trabajo y sus notas están intactos. Recupera a uno cuando haya espacio.",
        "suspendedPracticesHeading": "Prácticas apartadas",
        "suspendedPracticesBody": "Todas las versiones y todos los intentos están intactos. Recupera una cuando haya espacio.",
        "suspendedBySubscription": "Apartado por un cambio de plan",
        "suspendedByTutor": "Lo apartaste tú",
        "suspendedState": "Apartado",
        "restore": "Recuperar",
        "bringBackOnPlan": "Recuperar en tu plan",
        "invitationsHeading": "Invitaciones que reservan un lugar",
        "invitationsBody": "Una invitación pendiente reserva un lugar hasta que se acepta o caduca.",
        "invitationExpires": "Caduca el {0}",
        "invitationRevoke": "Retirar",
        "invitationState": "Pendiente",
        "aiExhaustedHint": "No te quedan generaciones con IA. La pestaña Manual sigue funcionando.",
        "aiRemainingHintOne": "Te queda 1 generación con IA.",
        "aiRemainingHintOther": "Te quedan {0} generaciones con IA.",
        "changeNotMade": "Ese cambio en tu plan no se hizo.",
        "selectionNotSaved": "Tu elección no se guardó."
    },
    "badge": {
        "published": "Publicada",
        "draft": "Borrador",
        "assigned": "Asignada",
        "error": "Errores",
        "archived": "Archivada",
        "setAside": "Apartada",
        "closing": "Cierra pronto",
        "lowScore": "Nota baja",
        "inProgress": "En curso",
        "notStarted": "Sin empezar"
    },
    "ui": {
        "search": {
            "label": "Buscar",
            "placeholder": "Buscar prácticas"
        },
        "attemptSummary": {
            "empty": "Todavía no hay intentos."
        },
        "score": {
            "ringLabel": "{0} de {1} correctas",
            "value": "{0} / {1} correctas"
        },
        "matching": {
            "notMatched": "Sin relacionar",
            "leftUnmatched": "Sin relacionar",
            "termsHeading": "Términos",
            "definitionsHeading": "Definiciones",
            "chooseFor": "Relación para {0}",
            "instructions": "Elige una relación para cada término. En una pantalla ancha también puedes arrastrar una definición sobre uno.",
            "clear": "Quitar la relación de {0}",
            "matchedWith": "Relacionada con {0}",
            "announceMatched": "{0} relacionada con {1}.",
            "announceUnmatched": "{0} sin relacionar."
        },
        "ordering": {
            "dropHere": "Suelta una opción aquí",
            "answerHeading": "Tu respuesta",
            "moveUp": "Subir {0}",
            "moveDown": "Bajar {0}",
            "availableHeading": "Opciones disponibles",
            "instructions": "Arrastra cada opción a su lugar, o usa sus botones para moverla.",
            "remove": "Quitar {0} de tu respuesta",
            "add": "Agregar {0} a tu respuesta",
            "announceMoved": "{0} movida a la posición {1}.",
            "announceReturned": "{0} devuelta a las opciones disponibles.",
            "allPlaced": "Todas las opciones están en tu respuesta.",
            "leftBlank": "En blanco"
        },
        "markdown": {
            "parsing": "Leyendo tu práctica…",
            "document": "Documento",
            "line": "Línea {0}",
            "fixInEditor": "Corregir en el editor",
            "stillHere": "Tu Markdown sigue aquí. Corrige las líneas de arriba y vuelve a intentarlo.",
            "dropTitle": "Suelta un archivo .md o pega Markdown",
            "browse": "Buscar archivos"
        },
        "images": {
            "dropTitle": "Arrastra imágenes aquí",
            "browse": "Elegir imágenes",
            "accepted": "PNG, JPEG o WebP, hasta {0} MB cada una. {1} imágenes a la vez.",
            "hint": "Agrega fotos o capturas de las preguntas. Athena las prepara en tu navegador y luego lee cada página como texto. Las imágenes se usan para la lectura y nunca se guardan.",
            "hintLabel": "Acerca de las imágenes",
            "selectedHeading": "Imágenes seleccionadas",
            "preview": "Vista previa de {0}",
            "removeAction": "Quitar",
            "remove": "Quitar {0}",
            "clearAll": "Quitar todas",
            "rejectedHeading": "Algunos archivos no se agregaron"
        },
        "documents": {
            "dropTitle": "Suelta los PDF aquí",
            "browse": "Elegir PDF",
            "accepted": "Archivos PDF, hasta {0} MB cada uno, {1} a la vez.",
            "hint": "Athena lee el texto de un PDF. Las páginas escaneadas, las fotos y los diagramas se omiten.",
            "hintLabel": "Acerca de los PDF",
            "rejectedHeading": "Algunos archivos no se agregaron",
            "selectedHeading": "Tus PDF",
            "listLabel": "PDF por leer, en el orden en que se leerán",
            "clear": "Quitar todos",
            "remove": "Quitar",
            "removeNamed": "Quitar {0}",
            "pending": "En espera",
            "reading": "Leyendo",
            "read": "Leído",
            "failed": "No se pudo leer"
        },
        "extraction": {
            "imageOf": "Imagen {0} de {1}",
            "pending": "En espera",
            "compressing": "Preparando",
            "extracting": "Leyendo",
            "extracted": "Leída",
            "failed": "No se pudo leer",
            "retry": "Intentar de nuevo",
            "retryImage": "Intentar de nuevo: {0}",
            "startingLabel": "Preparando tus imágenes…",
            "contentLabel": "El contenido leído de tus imágenes",
            "show": "Ver el contenido",
            "noText": "No se encontró texto en esas imágenes. Con fotos más nítidas suele leerse mejor.",
            "failedHeading": "No se pudieron leer las páginas",
            "failedBody": "Vuelve a intentarlo o quita una foto que haya salido mal y lee el resto.",
            "readingLabel": "Leyendo tus páginas…"
        },
        "field": {
            "optional": "Opcional"
        },
        "failure": {
            "connection": "No se pudo conectar con Athena. Revisa tu conexión a internet y vuelve a intentarlo.",
            "signedOut": "Tu sesión terminó. Inicia sesión de nuevo y vuelve a intentarlo.",
            "forbidden": "Tu cuenta no tiene permiso para hacer eso.",
            "notFound": "Eso ya no está disponible. Es posible que se haya eliminado.",
            "invalid": "No se pudo aceptar. Revisa lo que escribiste y vuelve a intentarlo.",
            "unexpected": "Algo salió mal de nuestro lado. Vuelve a intentarlo en un momento.",
            "retrying": "Intentando de nuevo…"
        },
        "toast": {
            "dismiss": "Cerrar"
        },
        "practiceCard": {
            "open": "Abrir"
        },
        "changeList": {
            "from": "de",
            "to": "a"
        },
        "select": {
            "search": "Buscar materias",
            "noResults": "No hay materias que coincidan."
        }
    },
    "email": {
        "signInCode": {
            "subject": "Tu código de acceso a Athena",
            "preview": "Tu código de acceso a Athena",
            "heading": "Inicia sesión en Athena",
            "body": "Escribe este código en la página que lo pidió. Funciona una sola vez y caduca en {0} minutos.",
            "footer": "Si no pediste iniciar sesión, ignora este correo. No pasa nada hasta que se use el código."
        },
        "connectionRequest": {
            "subject": "Tienes una solicitud de un tutor en Athena",
            "body": "{0} quiere conectarse contigo como tutor.",
            "instructions": "Crea una cuenta o inicia sesión en Athena para revisar la solicitud. Tú decides si la aceptas o la rechazas.",
            "open": "Abrir Athena"
        }
    },
    "userError": {
        "STUDENT_ALREADY_CLAIMED": "{0} ya tiene una cuenta.",
        "INVITATION_WRONG_ACCOUNT": "Esta invitación es para otro correo. Inicia sesión con el correo que usó tu tutor.",
        "NO_INVITATION": "Abre de nuevo tu enlace de invitación para unirte.",
        "INVALID_INVITATION": "Esta invitación ya no es válida.",
        "TUTOR_PROFILE_REQUIRED": "Solo una cuenta de tutor puede aceptar esta invitación.",
        "SUBJECT_UNAVAILABLE": "Elige una materia de la lista.",
        "NO_DRAFT": "No hay cambios sin publicar que publicar.",
        "VERSION_IMMUTABLE": "Una versión publicada no se puede cambiar. Edita la práctica para empezar un borrador nuevo.",
        "VERSION_NOT_DRAFT": "Solo se puede publicar un borrador.",
        "DRAFT_MUST_BE_PUBLISHED": "Publica la nueva versión antes de restaurar esta práctica.",
        "PRACTICE_NOT_ARCHIVED": "Archiva esta práctica antes de crear una versión nueva.",
        "NO_PUBLISHED_VERSION": "No hay una versión publicada que copiar.",
        "DRAFT_EXISTS": "Esta práctica ya tiene un borrador editable.",
        "INVALID_ANSWER": "Elige exactamente una respuesta correcta.",
        "INVALID_ORDER": "Ordena cada opción exactamente una vez.",
        "ANSWER_TOO_LONG": "Las respuestas aceptadas deben tener tres palabras o menos.",
        "QUESTION_TOO_FEW_OPTIONS": "Esta pregunta necesita al menos dos opciones.",
        "QUESTION_MISSING_ANSWER": "Agrega al menos una respuesta aceptada.",
        "QUESTION_TOO_FEW_PAIRS": "Una pregunta de relación necesita al menos dos pares.",
        "LAST_QUESTION": "Una práctica debe conservar al menos una pregunta.",
        "PRACTICE_NOT_PUBLISHED": "Esta práctica no tiene ninguna versión publicada que intentar.",
        "PRACTICE_ARCHIVED": "Esta práctica está archivada y no se puede empezar.",
        "PRACTICE_CLOSED": "Esta práctica ya no está disponible.",
        "MAX_ATTEMPTS_REACHED": "Ya has usado todos los intentos de esta práctica.",
        "ATTEMPT_NOT_SUBMITTED": "Este intento todavía no se ha entregado.",
        "PRACTICE_UNASSIGNED": "Esta práctica ya no está en tu lista.",
        "ATTEMPTS_REMAINING": "Todavía te queda un intento de esta práctica.",
        "ATTEMPT_ALREADY_SUBMITTED": "Este intento ya se entregó.",
        "UNKNOWN_QUESTION": "Se envió una respuesta para una pregunta que esta práctica no tiene ({0}).",
        "DUPLICATE_ANSWER": "La misma pregunta se respondió dos veces ({0}).",
        "WRONG_ANSWER_SHAPE": "Una respuesta no coincide con el tipo de pregunta a la que responde ({0}).",
        "OPTION_NOT_IN_QUESTION": "Una respuesta eligió una opción que la pregunta no tiene ({0}).",
        "PAIR_NOT_IN_QUESTION": "Una respuesta relacionó un elemento que la pregunta no tiene ({0}).",
        "MATCH_TARGET_NOT_IN_QUESTION": "Una respuesta relacionó algo que la pregunta no ofrece ({0}).",
        "DUPLICATE_MATCHED_PAIR": "El mismo elemento se relacionó dos veces ({0}).",
        "DUPLICATE_ORDERED_OPTION": "La misma opción se colocó dos veces ({0}).",
        "INPUT_TOO_LARGE": "El documento supera los {0} bytes.",
        "MISSING_TITLE": "No se encontró un único encabezado #.",
        "NO_QUESTIONS": "No se encontraron bloques de pregunta ##.",
        "TOO_MANY_QUESTIONS": "Más de {0} preguntas.",
        "MISSING_PROMPT": "Pregunta {0}: sin texto.",
        "MISSING_ANSWER": "Pregunta {0}: falta la línea **Answer:**.",
        "UNKNOWN_QUESTION_TYPE": "Pregunta {0}: \"{1}\" no es un tipo de pregunta.",
        "ANSWER_NOT_IN_OPTIONS": "Pregunta {0}: la respuesta \"{1}\" no coincide con la letra de ninguna opción.",
        "MULTIPLE_ANSWERS": "Pregunta {0}: una pregunta de respuesta única no puede tener varias respuestas.",
        "EMPTY_SHORT_ANSWER": "Pregunta {0}: no hay respuestas aceptadas con contenido.",
        "SHORT_ANSWER_TOO_LONG": "Pregunta {0}: \"{1}\" es demasiado larga. Una respuesta corta tiene como máximo {2} palabras.",
        "TOO_FEW_OPTIONS": "Pregunta {0}: menos de {1} opciones.",
        "TOO_MANY_OPTIONS": "Pregunta {0}: más de {1} opciones.",
        "DUPLICATE_OPTION_LABEL": "Pregunta {0}: la misma letra de opción dos veces.",
        "EMPTY_OPTION_TEXT": "Pregunta {0}: la opción {1} no tiene texto.",
        "DUPLICATE_OPTION_TEXT": "Pregunta {0}: dos opciones dicen lo mismo, \"{1}\".",
        "ANSWER_NOT_IN_ORDER": "Pregunta {0}: la respuesta debe listar todas las letras de las opciones, en orden, por ejemplo \"A, C, B, D\".",
        "DUPLICATE_ORDER_ITEM": "Pregunta {0}: la respuesta nombra \"{1}\" dos veces, y cada letra va exactamente una vez.",
        "INCOMPLETE_ORDER": "Pregunta {0}: la respuesta omite {1}, y cada letra va exactamente una vez.",
        "MISSING_PAIRS": "Pregunta {0}: una pregunta de relacionar necesita líneas \"- izquierda -> derecha\".",
        "TOO_FEW_PAIRS": "Pregunta {0}: menos de {1} parejas que relacionar.",
        "TOO_MANY_PAIRS": "Pregunta {0}: más de {1} parejas que relacionar.",
        "EMPTY_PAIR_LEFT": "Pregunta {0}: una pareja sin nada a la izquierda de la flecha.",
        "EMPTY_PAIR_RIGHT": "Pregunta {0}: una pareja sin nada a la derecha de la flecha.",
        "DUPLICATE_PAIR_LEFT": "Pregunta {0}: dos elementos de la izquierda dicen lo mismo, \"{1}\".",
        "DUPLICATE_PAIR_RIGHT": "Pregunta {0}: dos elementos de la derecha dicen lo mismo, \"{1}\".",
        "IMAGE_TOO_LARGE": "Una de esas imágenes es demasiado grande para leerla. Prueba con una foto más pequeña.",
        "EXTRACTION_EMPTY": "No se pudo leer texto de esas imágenes.",
        "EXTRACTION_REFUSED": "Esas imágenes no se pudieron leer.",
        "EXTRACTION_FAILED": "Athena no pudo leer esas imágenes en este momento. Vuelve a intentarlo.",
        "EXTRACTION_UNAVAILABLE": "La lectura de imágenes no está disponible ahora. Escribe la práctica en la pestaña Manual.",
        "GENERATION_UNAVAILABLE": "Crear prácticas con IA no está disponible en este momento. Escribe la práctica en la pestaña Manual.",
        "GENERATION_PROVIDER_OVERRIDE_DISABLED": "La selección del proveedor de IA está desactivada en este servidor.",
        "GENERATION_PROVIDER_NOT_CONFIGURED": "{0} no está configurado en este servidor.",
        "GENERATION_EMPTY": "No llegó nada. Vuelve a intentarlo o escribe la práctica en la pestaña Manual.",
        "GENERATION_TYPE_MISMATCH": "Las preguntas generadas no coinciden con el tipo de práctica seleccionado. Vuelve a intentarlo; no se usó ningún crédito de IA.",
        "GENERATION_REFUSED": "Esas páginas no se pudieron convertir en una práctica. Revisa que muestren el material sobre el que quieres preguntas.",
        "GENERATION_RATE_LIMITED": "Athena está generando muchas prácticas en este momento. Espera un momento y vuelve a intentarlo.",
        "GENERATION_TIMEOUT": "Tardó demasiado. Vuelve a intentarlo o pide menos preguntas.",
        "GENERATION_FAILED": "No se pudo generar la práctica. Vuelve a intentarlo.",
        "IMAGES_TOO_LARGE": "Esas imágenes son demasiado grandes para leerlas juntas. Quita algunas y vuelve a intentarlo.",
        "EXTRACTION_INCOMPLETE": "No se pudieron leer todas las páginas. Vuelve a intentarlo.",
        "EXTRACTION_UNREACHABLE": "Athena no pudo enviar esas imágenes. Puede que juntas sean demasiado grandes, o que se haya cortado la conexión. Vuelve a intentarlo con menos páginas.",
        "MIXED_SOURCES": "Usa imágenes o PDF para una práctica, no ambos. Quita uno de los dos para continuar.",
        "NO_SOURCES": "Primero agrega al menos una imagen o un PDF.",
        "PDFS_TOO_LARGE": "Esos PDF son demasiado grandes para leerlos juntos. Quita uno y vuelve a intentarlo.",
        "SOURCE_TOO_LARGE": "Esos PDF tienen más texto del que puede usar una práctica. Prueba con menos.",
        "PDF_EMPTY": "{0} está vacío.",
        "PDF_UNREADABLE": "No se pudo abrir {0}. Revisa que el archivo sea un PDF que funcione.",
        "PDF_ENCRYPTED": "{0} está protegido con contraseña. Quita la contraseña y súbelo de nuevo.",
        "PDF_NO_TEXT": "{0} no tiene texto legible. Las páginas escaneadas y las imágenes no son compatibles: mejor fotografía las páginas.",
        "PDF_TOO_LARGE": "{0} es demasiado grande para leerlo.",
        "PDF_FAILED": "No se pudo leer {0}. Vuelve a intentarlo.",
        "PDF_TOO_MANY_PAGES": "{0} tiene más de {1} páginas. Sube solo las páginas que necesitas en un PDF más corto.",
        "PDF_TIMEOUT": "Leer {0} tardó demasiado. Prueba con un PDF más corto.",
        "ATTEMPT_EXPIRED": "Se acabó el tiempo de esta práctica. Se entregó tal como estaba.",
        "STUDENT_LIMIT_REACHED": "Tu plan permite {0} estudiantes y estás usando {1}. Aparta a un estudiante o solicita una mejora.",
        "PRACTICE_LIMIT_REACHED": "Tu plan permite {0} prácticas activas y tienes {1}. Archiva una o solicita una mejora.",
        "QUESTION_LIMIT_EXCEEDED": "Tu plan permite {0} preguntas por práctica y esta tiene {1}. Acórtala o solicita una mejora.",
        "AI_ALLOWANCE_EXHAUSTED": "Has usado las {0} generaciones con IA. Todavía puedes escribir una práctica en la pestaña Manual.",
        "EXTRACTION_ALLOWANCE_EXHAUSTED": "Has usado las {0} lecturas de imágenes con IA disponibles por ahora. Todavía puedes subir un PDF o escribir una práctica en la pestaña Manual.",
        "AI_REQUEST_IN_PROGRESS": "Otra solicitud de IA todavía se está procesando. Espera a que termine y vuelve a intentarlo.",
        "RATE_LIMITED": "Demasiadas solicitudes en poco tiempo. Vuelve a intentarlo en {0} minutos.",
        "TIMED_PRACTICE_UNAVAILABLE": "Las prácticas cronometradas forman parte de los planes de pago. Desactiva el límite de tiempo para guardar esta configuración.",
        "TIMED_PRACTICE_UNPUBLISHABLE": "Las prácticas cronometradas forman parte de los planes de pago. Desactiva el límite de tiempo en la configuración de la práctica y luego publícala.",
        "MULTIPLE_ATTEMPTS_UNAVAILABLE": "Los intentos múltiples forman parte de los planes de pago. Establece el máximo de intentos en 1 para guardar esta configuración.",
        "PRACTICE_AVAILABILITY_UNAVAILABLE": "La disponibilidad de prácticas forma parte de los planes de pago. Elimina la fecha de finalización para guardar esta configuración.",
        "SUBSCRIPTION_CHANGED": "Esta suscripción cambió mientras se guardaba el cambio. No se modificó nada; revísala y vuelve a intentarlo.",
        "DETAILED_HISTORY_UNAVAILABLE": "Los intentos anteriores, pregunta por pregunta, forman parte de los planes de pago. Tu nota se conserva.",
        "PRACTICE_SUSPENDED": "Tu plan apartó esta práctica. Recupérala para volver a usarla.",
        "STUDENT_CONNECTION_SUSPENDED": "Tu plan apartó a este estudiante. Recupéralo para asignarle prácticas.",
        "PRACTICE_OVER_QUESTION_LIMIT": "Esta práctica es más larga de lo que permite el plan, así que no pueden empezar intentos nuevos. No se ha modificado.",
        "PRACTICE_TIMED_WITHOUT_PLAN": "Esta práctica está cronometrada y las prácticas cronometradas forman parte de los planes de pago. Desactiva el límite de tiempo o solicita una mejora.",
        "GENERATION_ALREADY_DELIVERED": "Esa generación ya se ejecutó. Vuelve a pedirla para obtener una práctica nueva.",
        "GENERATION_IN_PROGRESS": "Esa práctica todavía se está generando. Espera un momento y vuelve a pulsar Generar práctica; no se usará otro crédito de IA.",
        "PLAN_NOT_AN_UPGRADE": "Ese plan no es una mejora respecto al que tienes.",
        "PLAN_UNCHANGED": "Ese es el plan que ya tienes.",
        "UPGRADE_NEEDS_REQUEST": "Solicita una mejora. Se revisa antes de aplicarse.",
        "UPGRADE_REQUEST_NOT_PENDING": "Esa solicitud ya fue respondida.",
        "NO_SCHEDULED_CHANGE": "No hay ningún cambio de plan programado.",
        "SCHEDULED_BY_ADMIN": "Athena programó este cambio de tu plan. Contacta con soporte para modificarlo.",
        "NO_PAID_ACCESS": "Esa cuenta no tiene acceso de pago que finalizar.",
        "INVALID_DOWNGRADE_SELECTION": "Cada estudiante y práctica seleccionados deben estar activos y pertenecerte.",
        "DOWNGRADE_SELECTION_TOO_LARGE": "Eso supera lo que admite el plan nuevo: {0} estudiantes y {1} prácticas.",
        "INVITATION_NOT_PENDING": "Esa invitación ya se usó o se retiró.",
        "DECISION_NOTE_REQUIRED": "Escribe una nota que explique la decisión.",
        "CONCURRENT_UPDATE": "Este registro cambió mientras lo editabas. Vuelve a cargarlo y vuelve a intentarlo.",
        "RECORD_REFERENCED": "Esto todavía está en uso y no se puede eliminar. Deshabilita la cuenta o desactiva la materia.",
        "ROLE_DEPENDENCIES": "Este perfil tiene actividad o historial y no se puede quitar.",
        "ADMIN_SELF_PROTECTION": "No puedes deshabilitar ni eliminar tu propia cuenta ni quitarte el acceso de administrador.",
        "LAST_ADMIN": "El último administrador disponible debe conservar el acceso.",
        "ADMIN_ACCESS_REVOKED": "Tu acceso de administrador ya no está disponible.",
        "ADMIN_PROVISIONING_REQUIRED": "El acceso de administrador se otorga con el comando de aprovisionamiento de administradores, no desde esta pantalla.",
        "STUDENT_INVITATION_REQUIRED": "El perfil de estudiante se crea cuando el estudiante acepta la solicitud de conexión de un tutor.",
        "DUPLICATE_EMAIL": "Ya existe una cuenta con este correo electrónico.",
        "SUBJECT_CATEGORY_NOT_FOUND": "No se encontró la categoría de materias.",
        "INVALID_SUBJECT_CODE": "Usa al menos 3 letras mayúsculas ASCII (A–Z), sin números, espacios ni símbolos.",
        "DUPLICATE_SUBJECT_CODE": "Ya existe una materia con este código.",
        "MANAGED_RECORD_NOT_FOUND": "Este registro ya no existe. Actualiza la lista.",
        "SUBJECT_TRANSLATIONS_REQUIRED": "Escribe nombres válidos y no vacíos en español e inglés.",
        "INVALID_MANAGEMENT_INPUT": "Revisa los campos y vuelve a intentarlo.",
        "STUDENT_ALREADY_CONNECTED": "Este estudiante ya está conectado contigo.",
        "CONNECTION_TUTOR_LIMIT": "Este tutor no tiene cupos disponibles. La solicitud sigue pendiente.",
        "CONNECTION_REQUEST_CLOSED": "Esta solicitud ya no está pendiente.",
        "CONNECTION_REQUEST_LIMIT": "Alcanzaste el límite diario de solicitudes. Vuelve a intentarlo mañana.",
        "LEGACY_LINKS_DISABLED": "Envía una solicitud de conexión desde Agregar estudiante.",
        "DELETION_IMPACT_CHANGED": "Lo que afecta esta eliminación cambió después de revisarlo. Revisa las cifras nuevas y vuelve a confirmar.",
        "GENERATION_QUESTION_TYPES_REQUIRED": "Selecciona al menos un tipo de pregunta.",
        "GENERATION_QUESTION_TYPES_PLAN": "Tu plan incluye solo selección múltiple. Elige selección múltiple o solicita acceso a Premium.",
        "AI_WEIGHTS_INVALID": "Ingresa porcentajes enteros de 0 a 100 que sumen 100.",
        "AI_PROVIDER_UNAVAILABLE": "Un proveedor con asignación positiva no tiene clave de API en el servidor.",
        "AI_CONFIGURATION_CONFLICT": "La configuración cambió. Recarga y revisa la nueva versión antes de guardar.",
        "STUDENT_LIMIT_BELOW_USAGE": "El límite no puede ser menor que los {0} espacios de estudiantes ocupados o reservados. Libera espacios y vuelve a intentarlo.",
        "STUDENT_OVERRIDE_REQUIRES_PAID_PLAN": "Un límite personalizado de estudiantes requiere un plan de pago activo."
    },
    "management": {
        "subjects": "Materias",
        "createUser": "Crear usuario",
        "createSubject": "Crear materia",
        "editUser": "Perfil",
        "email": "Correo electrónico",
        "name": "Nombre",
        "language": "Idioma preferido",
        "roles": "Perfiles",
        "profilesNone": "Sin perfil de tutor ni de estudiante",
        "profilesTutorStudent": "Tutor y estudiante",
        "profilesHelper": "Estudiante solo está disponible si la cuenta ya tiene un perfil de estudiante.",
        "sort": "Ordenar por",
        "newest": "Más recientes",
        "code": "Código permanente",
        "spanishName": "Nombre en español",
        "englishName": "Nombre en inglés",
        "save": "Guardar cambios",
        "dangerZone": "Zona de peligro",
        "deleteAccount": "Eliminar cuenta",
        "deleteAccountPermanently": "Eliminar cuenta permanentemente",
        "confirmDeleteTitle": "¿Eliminar {0} de forma permanente?",
        "confirmDeleteBody": "Se elimina {0} con todo lo que le pertenece: sus perfiles, sus prácticas y todos los intentos en ellas, su suscripción y su uso, y las entradas de auditoría que la mencionan. Las cuentas de otras personas se mantienen. No se puede deshacer.",
        "confirmDeleteInput": "Escribe el correo de la cuenta para confirmar",
        "keepAccount": "Conservar la cuenta",
        "deleting": "Eliminando…",
        "disable": "Deshabilitar cuenta",
        "reactivate": "Reactivar cuenta",
        "disableTitle": "¿Deshabilitar {0}?",
        "disableBody": "{0} cierra sesión en todas partes y no puede volver a entrar hasta que se reactive la cuenta. Sus prácticas, estudiantes e historial se conservan.",
        "keepActive": "Mantener la cuenta activa",
        "reason": "Motivo del cambio",
        "reasonHelper": "Obligatorio. Queda en el registro de auditoría.",
        "previous": "Anterior",
        "next": "Siguiente",
        "page": "{0}–{1} de {2}",
        "saved": "Cambios guardados.",
        "deletedUser": "Cuenta eliminada permanentemente.",
        "failed": "No se pudo guardar el cambio. Vuelve a intentarlo.",
        "emailReadOnly": "El correo electrónico no se puede cambiar aquí.",
        "createHelp": "Las cuentas nuevas empiezan sin verificar. Inician sesión con un código por correo, Google o Microsoft. Crear una cuenta de estudiante no crea un perfil de estudiante ni conecta a un tutor: el estudiante debe aceptar la solicitud de conexión de un tutor.",
        "personalDetails": "Datos personales",
        "accountSettings": "Configuración de la cuenta",
        "tutorProfile": "Perfil de tutor",
        "studentProfile": "Perfil de estudiante",
        "tutorNameHelp": "Este nombre se muestra en Athena como el nombre del tutor.",
        "firstName": "Nombre",
        "lastName": "Apellidos",
        "deleteUserEffect": "Elimina permanentemente {0} y todo lo que solo esta cuenta posee. No se puede deshacer.",
        "deleteSubjectEffect": "Elimina {0} y sus nombres para siempre. Solo se puede eliminar una materia que ninguna práctica use; desactiva la que esté en uso.",
        "deleteSubject": "Eliminar materia",
        "deleteSubjectTitle": "¿Eliminar {0} de forma permanente?",
        "deleteSubjectBody": "Se eliminan {0} y sus nombres en español e inglés. Athena se niega si alguna práctica la usa; en ese caso, desactívala. No se puede deshacer.",
        "deleteSubjectPermanently": "Eliminar la materia de forma permanente",
        "keepSubject": "Conservar la materia",
        "subjectEffect": "Las materias inactivas no se pueden elegir para prácticas nuevas. Las prácticas existentes y sus etiquetas históricas se conservan.",
        "unsaved": "¿Descartar los cambios sin guardar?",
        "unsavedBody": "Tus cambios no se han guardado. Si sales de esta página, se descartarán.",
        "keepEditing": "Seguir editando",
        "leaveWithoutSaving": "Salir sin guardar",
        "relationships": "Tutores del estudiante",
        "codeHelp": "Al menos 3 letras mayúsculas ASCII (A–Z). No se puede cambiar después de crearla.",
        "usageOther": "{0} prácticas",
        "usageOne": "1 práctica",
        "notSaved": "El cambio no se guardó.",
        "userCreated": "Cuenta creada.",
        "deleteUnconfirmed": "Athena no pudo confirmar que la cuenta se eliminó. Vuelve a cargar la cuenta antes de intentarlo de nuevo.",
        "subjectCreated": "Materia creada.",
        "subjectDeleted": "Materia eliminada.",
        "roleStudentInvited": "Estudiante (se une al aceptar la solicitud de conexión de un tutor)",
        "featureFlags": "Funciones experimentales",
        "featureFlagsHelp": "Capacidades internas asignadas a esta cuenta. Se aplican en la siguiente solicitud del usuario.",
        "practiceProviderOverrideFlag": "Cambio de proveedor para generar prácticas",
        "practiceProviderOverrideFlagHelp": "Muestra las opciones Gemini y OpenAI solo en el flujo Crear práctica automáticamente de este tutor. La elección se aplica a una sola generación.",
        "localDevelopmentFlag": "Diagnósticos para desarrollo",
        "localDevelopmentFlagHelp": "Muestra el informe de compresión de imágenes y el texto extraído en el flujo Crear práctica automáticamente de este usuario.",
        "saveFeatureFlag": "Guardar función experimental",
        "availableFeatureFlags": "Funciones disponibles",
        "enabledFeatureFlags": "Funciones habilitadas",
        "addFeatureFlag": "Habilitar {0}",
        "removeFeatureFlag": "Quitar {0}",
        "flagToEnable": "Por habilitar",
        "flagToDisable": "Por quitar",
        "noEnabledFeatureFlags": "Elige una función disponible para habilitarla.",
        "allFeatureFlagsSelected": "Todas las funciones disponibles están seleccionadas.",
        "featureFlagsUnsaved": "Cambios sin guardar. Guarda para aplicar esta selección.",
        "featureFlagsSelectionHelp": "Los cambios se aplican solo después de guardar.",
        "featureFlagsStale": "Esta cuenta cambió mientras editabas. Descarta tus cambios para cargar la selección actual.",
        "saveFeatureFlags": "Guardar funciones experimentales",
        "resetFeatureFlags": "Descartar cambios",
        "errors": {
            "reason": "Escribe el motivo de este cambio.",
            "name": "Escribe un nombre.",
            "firstName": "Escribe un nombre.",
            "lastName": "Escribe los apellidos.",
            "email": "Escribe un correo electrónico válido.",
            "code": "Usa al menos 3 letras mayúsculas ASCII (A–Z), sin números, espacios ni símbolos.",
            "spanishName": "Escribe el nombre en español.",
            "englishName": "Escribe el nombre en inglés.",
            "plan": "Elige un plan.",
            "endDate": "Elige la fecha en que termina el acceso de pago.",
            "adjustment": "Escribe un número entero distinto de cero.",
            "tooLong": "Usa {0} caracteres o menos.",
            "confirmEmail": "Escribe el correo exactamente como aparece: {0}",
            "decisionNote": "Escribe una nota que explique la decisión.",
            "generic": "Revisa este campo."
        },
        "deletionImpact": {
            "loading": "Contando lo que se elimina…",
            "loadError": "Athena no pudo contar lo que se elimina. Cierra esto y vuelve a intentarlo.",
            "deleted": "Se elimina para siempre",
            "detached": "Se conserva, sin esta cuenta",
            "preserved": "No se ve afectado",
            "otherStudentsTitle": "Esto también elimina el historial de otros estudiantes",
            "otherStudentsBody": "Intentos de otros estudiantes en las prácticas de este tutor: {0}, de {1} estudiantes. Sus cuentas se conservan, pero estos intentos y sus notas no se pueden recuperar.",
            "kinds": {
                "sessions": "Sesiones iniciadas",
                "providerIdentities": "Inicios de sesión con Google o Microsoft",
                "signInCodes": "Códigos de acceso sin usar",
                "featureFlags": "Funciones habilitadas",
                "tutorStudentLinks": "Conexiones entre tutor y estudiante",
                "connectionRequests": "Solicitudes de conexión",
                "invitations": "Invitaciones",
                "provisionalStudents": "Estudiantes que solo agregó este tutor y que nunca iniciaron sesión",
                "practices": "Prácticas",
                "practiceVersions": "Versiones de prácticas",
                "questions": "Preguntas",
                "assignments": "Asignaciones",
                "attempts": "Intentos",
                "subscriptions": "Suscripción",
                "usagePeriods": "Períodos de uso",
                "aiUsageEntries": "Registros de uso de IA",
                "upgradeRequests": "Solicitudes de mejora de plan",
                "auditEntries": "Entradas de auditoría",
                "rateLimitCounters": "Contadores de límite de solicitudes",
                "upgradeDecisions": "Solicitudes de mejora de otros tutores que respondió este administrador",
                "downgradeSelections": "Selecciones de otros tutores para bajar de plan",
                "connectedStudents": "Estudiantes conectados, que conservan sus cuentas",
                "connectedTutors": "Tutores conectados, que conservan sus cuentas",
                "sharedProvisionalStudents": "Estudiantes que otros tutores también agregaron"
            }
        }
    },
    "connections": {
        "title": "Solicitudes",
        "pendingTitle": "Solicitudes pendientes",
        "email": "Correo del estudiante",
        "emailHelp": "Usa el correo con el que el estudiante inicia sesión. El estudiante decide si acepta tu solicitud.",
        "emailError": "Escribe un correo válido.",
        "send": "Agregar estudiante",
        "sent": "Solicitud enviada.",
        "alreadyConnected": "Ya está conectado.",
        "pending": "Pendiente",
        "cancel": "Cancelar solicitud",
        "accept": "Aceptar",
        "decline": "Rechazar",
        "none": "No tienes solicitudes pendientes",
        "noneDescription": "Las nuevas solicitudes de conexión de tutores aparecerán aquí para que las revises.",
        "failed": "No se pudo actualizar la solicitud. Vuelve a intentarlo.",
        "accepted": "Solicitud aceptada.",
        "declined": "Solicitud rechazada.",
        "fromTutor": "{0} quiere conectarse contigo como tutor.",
        "requested": "Solicitada el {0}",
        "nav": "Solicitudes",
        "navCount": "Solicitudes ({0})",
        "notificationFailed": "La solicitud se guardó, pero no pudimos enviar el correo de notificación. Puedes cancelarla y volver a enviarla más tarde.",
        "legacyAccept": "Aceptar invitación",
        "pendingNoSlot": "Las solicitudes pendientes no ocupan un lugar de estudiante. El lugar solo se ocupa cuando el estudiante acepta."
    },
    "progressChart": {
        "notIncluded": "El progreso a lo largo del tiempo forma parte de los planes de pago. Cada nota sigue en la lista de abajo.",
        "title": "Progreso en el tiempo",
        "viewLabel": "Vista",
        "viewAttempts": "Intentos",
        "viewDaily": "Promedios diarios",
        "viewAttemptsHelp": "Cada punto es un intento entregado.",
        "viewDailyHelp": "Cada punto es el promedio de una materia en un día (UTC).",
        "subjectFilter": "Materia",
        "everySubject": "Todas las materias",
        "recentSubjects": "Las {0} materias más recientes",
        "scopeNote": "Se muestran las {0} materias practicadas más recientemente. Elige una materia para ver cualquier otra.",
        "summary": "{0} en {1}",
        "attemptsOne": "1 intento",
        "attemptsOther": "{0} intentos",
        "daysOne": "1 promedio diario",
        "daysOther": "{0} promedios diarios",
        "subjectsOne": "1 materia",
        "subjectsOther": "{0} materias",
        "practicesOne": "1 práctica",
        "practicesOther": "{0} prácticas",
        "dailyScope": "{0} en {1}",
        "presentation": "Mostrar el progreso como",
        "chartTab": "Gráfico",
        "tableTab": "Tabla",
        "legendLabel": "Materias en este gráfico",
        "labelAttempts": "Notas de {0}, un punto por intento entregado: {1}, en una escala de 0 a 100%.",
        "labelDaily": "Notas promedio diarias de {0}, un punto por materia y día: {1}, en una escala de 0 a 100%.",
        "noteAttempts": "Una línea une los intentos repetidos de una misma práctica. Las prácticas distintas no se unen: sus notas no son directamente comparables.",
        "noteDaily": "Una línea une los promedios diarios de una materia. El promedio de un día puede incluir intentos de prácticas distintas.",
        "percent": "{0}%",
        "attemptNumber": "Intento {0}",
        "dailyAverage": "Promedio diario",
        "noAttempts": "Las notas aparecerán aquí cuando {0} entregue una práctica.",
        "noSubjectData": "No hay intentos entregados en esta materia para esta vista.",
        "attemptsCaption": "Todos los intentos del gráfico, del más antiguo al más reciente",
        "dailyCaption": "Todos los promedios diarios del gráfico, del más antiguo al más reciente",
        "columnDate": "Entregado",
        "columnDay": "Día (UTC)",
        "columnSubject": "Materia",
        "columnPractice": "Práctica",
        "columnAttempt": "Intento",
        "columnScore": "Nota",
        "columnScope": "Promedia",
        "columnAverage": "Promedio"
    },
    "profile": {
        "title": "Mi perfil",
        "description": "Tu nombre se comparte entre tus perfiles de Athena."
    },
    "aiAnalytics": {
        "title": "Comparación de proveedores de IA",
        "body": "Compara los proveedores asignados con solicitudes observadas. Son resultados descriptivos, no pruebas de corrección educativa.",
        "overview": "Resumen",
        "comparison": "Comparación por proveedor",
        "models": "Modelos exactos",
        "trends": "Tendencias diarias (UTC)",
        "diagnostics": "Diagnóstico de generaciones",
        "experiment": "Configuración del experimento",
        "pricing": "Precios de modelos por versión",
        "from": "Desde (AAAA-MM-DD, UTC)",
        "to": "Hasta (AAAA-MM-DD, UTC)",
        "provider": "Proveedor asignado",
        "model": "Modelo exacto",
        "operation": "Operación",
        "version": "Versión de configuración",
        "status": "Estado",
        "allocation": "Asignación",
        "all": "Todos",
        "generation": "Generación de prácticas",
        "extraction": "Extracción de imágenes",
        "experimentMode": "Experimento aleatorio",
        "overrideMode": "Selección autorizada",
        "defaultMode": "Predeterminado del servidor",
        "requests": "Solicitudes",
        "successRate": "Tasa de éxito",
        "averageLatency": "Latencia promedio",
        "medianLatency": "Latencia mediana",
        "p95Latency": "Latencia p95",
        "cost": "Coste estimado de API (USD)",
        "costPerSuccess": "Coste por práctica exitosa",
        "inputTokens": "Tokens de entrada",
        "outputTokens": "Tokens de salida",
        "cachedTokens": "Tokens de entrada en caché",
        "reasoningTokens": "Tokens de razonamiento",
        "totalTokens": "Tokens totales",
        "tokensPerPractice": "Promedio de tokens por práctica exitosa",
        "markdownValidity": "Validez de Markdown",
        "schemaValidity": "Validez del esquema",
        "questions": "Promedio de preguntas generadas",
        "editRate": "Tasa de edición del tutor",
        "publicationRate": "Tasa de publicación",
        "metric": "Métrica",
        "samples": "{0} medidos / {1} solicitudes",
        "noData": "Ninguna solicitud coincide con estas fechas y filtros.",
        "unavailable": "No disponible",
        "latencyUnit": "{0} ms",
        "costCoverage": "Los costes cubren {0} de {1} solicitudes. Los totales excluyen las estimaciones ausentes.",
        "methodology": "Las solicitudes fallidas y sin finalización conocida permanecen en el denominador. Las métricas usan la asignación original; el diagnóstico muestra la ejecución real. Filtra por asignación para separar selecciones autorizadas. La edición mide cambios netos antes de la primera publicación; excluye reemplazos ambiguos.",
        "qualityNote": "La validación mide el cumplimiento del formato. Las preguntas candidatas a duplicadas tienen textos idénticos, pero no prueban duplicación. La publicación y la edición miden el comportamiento del tutor, no la corrección educativa.",
        "quality": "Calidad y comportamiento del tutor",
        "missingAnswers": "Respuestas ausentes",
        "missingExplanations": "Explicaciones ausentes",
        "invalidReferences": "Referencias de respuesta inválidas",
        "malformedQuestions": "Diagnósticos de preguntas mal formadas",
        "duplicates": "Textos de pregunta repetidos",
        "edited": "Preguntas editadas",
        "deleted": "Preguntas eliminadas",
        "added": "Preguntas agregadas",
        "explanationsEdited": "Explicaciones editadas",
        "optionsEdited": "Opciones editadas",
        "pipelineCost": "Coste estimado del proceso",
        "pipelineLatency": "Tiempo promedio de procesamiento (extracción + generación)",
        "reliability": "Fiabilidad",
        "published": "Prácticas publicadas",
        "sort": "Orden del diagnóstico",
        "newest": "Más recientes primero",
        "oldest": "Más antiguas primero",
        "slowest": "Mayor duración primero",
        "highestCost": "Mayor coste del proceso primero",
        "timestamp": "Fecha y hora",
        "executedProvider": "Proveedor ejecutado",
        "duration": "Duración",
        "questionCount": "Preguntas generadas",
        "errorCategory": "Categoría del fallo",
        "details": "Detalles técnicos",
        "chartTable": "Ver datos diarios",
        "chartLegend": "Proveedores del gráfico",
        "enabled": "Activar experimento",
        "openaiWeight": "Asignación de OpenAI (%)",
        "geminiWeight": "Asignación de Gemini (%)",
        "effective": "Asignación efectiva: OpenAI {0}% / Gemini {1}%, versión {2}",
        "configHelp": "Los cambios rigen desde la siguiente solicitud admitida. Al desactivar se usa el proveedor predeterminado. Las asignaciones positivas requieren claves de API del servidor.",
        "invalidWeights": "Ingresa porcentajes enteros de 0 a 100 que sumen 100.",
        "save": "Guardar configuración",
        "saved": "Configuración guardada",
        "saveError": "El cambio no se guardó. Conserva tus valores. Vuelve a intentarlo.",
        "conflict": "La configuración cambió. Recarga y revisa la nueva versión antes de guardar.",
        "reload": "Recargar configuración",
        "keyMissing": "Un proveedor con asignación positiva no tiene clave de API en el servidor.",
        "inputRate": "USD de entrada / millón de tokens",
        "outputRate": "USD de salida / millón de tokens",
        "cacheRate": "USD de entrada en caché / millón de tokens",
        "cacheWriteRate": "USD de escritura en caché / millón de tokens",
        "priceVersion": "Versión de precios",
        "effectiveAt": "Vigente desde (UTC)",
        "sourceUrl": "Fuente de precios verificada (HTTPS)",
        "registerPrice": "Registrar precios",
        "priceSaved": "Precios registrados",
        "priceHelp": "Usa el modelo exacto de la respuesta y tarifas verificadas. Las tarifas de caché vacías significan no disponibles. Las versiones nuevas afectan solicitudes futuras; las estimaciones históricas conservan sus tarifas originales.",
        "invalidPricing": "Ingresa un modelo, versión, fuente HTTPS verificada, motivo y tarifas no negativas.",
        "applyFilters": "Aplicar filtros",
        "invalidDates": "Ingresa un rango válido de hasta 366 días.",
        "pageSummary": "{0} registros de diagnóstico",
        "running": "En ejecución",
        "succeeded": "Exitosa",
        "failed": "Fallida",
        "abandoned": "Finalización desconocida",
        "unknown": "Desconocida",
        "abandonedHelp": "La reserva venció antes de guardar un estado final; el uso y la latencia no están disponibles.",
        "errorTimeout": "Tiempo agotado",
        "errorRateLimit": "Límite de solicitudes",
        "errorRefused": "Rechazo del proveedor",
        "errorInvalidResponse": "Respuesta inválida",
        "errorIncomplete": "Respuesta incompleta",
        "errorCancelled": "Cancelada",
        "errorNotConfigured": "Proveedor no disponible",
        "errorProvider": "Error del proveedor",
        "errorInternal": "Fallo interno",
        "errorDelivery": "Falló la entrega del borrador",
        "errorParsing": "Análisis de Markdown",
        "errorSchema": "Validación del esquema",
        "errorType": "Tipo de pregunta diferente",
        "errorLease": "Reserva vencida",
        "modelNote": "La comparación de modelos cuenta los intentos reales de cada proveedor. Los reintentos y cambios de proveedor pueden aportar a varios modelos; la comparación anterior cuenta cada solicitud lógica una sola vez.",
        "errorRecovered": "Estado final recuperado; detalles del fallo no disponibles",
        "nav": "Proveedores de IA",
        "tokensPerRequest": "Promedio de tokens por solicitud",
        "extractionCostPerSuccess": "Coste por extracción exitosa",
        "extractionTokensPerSuccess": "Promedio de tokens por extracción exitosa"
    }
}
